import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import Modal from "react-modal"; // Install react-modal for modal functionality
import { FaLock, FaMapMarkerAlt } from "react-icons/fa";
import FeedPost from "./feedpost/FeedPost";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import profileData from "./feedpost/profiledata";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar";
import LeftResponsivesidebar from "../components/sidebar/left-responsive";
import Rightsidebar from "../components/sidebar/rightsidebar";
import RightResponsivesidebar from "../components/sidebar/right-responsive";
import Headmenu from "../components/sidebar/headmenu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Createpost from "../components/feedpost/createpost";
import { liveStreamPath } from "./marketplace/LiveShopColumn";
import profileimg from "../assets/profile.png";
import ReactPlayer from "react-player";
import groupimg from "../assets/groupimg.png";
import play from "../assets/play.png";
import viewIcon from "../assets/images/icons/viewIcon.png";
import likeIcon from "../assets/images/icons/likeIcon.png";
import shareIcon from "../assets/images/icons/shareIcon.svg";
import commentIcon from "../assets/images/icons/commentIcon.svg";
import smileyIcon from "../assets/images/icons/smileyIcon.png";
import Viewpost from "./feedpost/viewpost";
import like from "../assets/images/icons/like.png";
import calender from "../assets/images/icons/calendar-icon.png";
import crtpostimg from "../assets/images/crtpostimg.png";
import Microphone from "../assets/images/icons/microphone.png";
import Smiley from "../assets/images/icons/Smiley.svg";
import videoicon from "../assets/images/icons/video.svg";
import galleryicon from "../assets/images/icons/gallery.svg";
import goliveprf from "../assets/images/golive-prf.png";
import messagetext from "../assets/images/icons/message-text.png";
import morecircle from "../assets/images/icons/more-circle.svg";
import leftconnect from "../assets/images/icons/leftconnect.png";
import Redheart from "../assets/images/icons/red-heart.svg";
import RedlikeIcon from "../assets/images/icons/redlikeIcon.svg";
import Whiteheart from "../assets/images/icons/white-heart.svg";
import postData from "../components/feedpost/postdata";
import global from "../assets/images/icons/global.svg";
import greenglobal from "../assets/images/icons/green-global.png";
import PostDonatePanel from "./PostDonatePanel";
import greenbigglobal from "../assets/images/icons/green-big-globel.png";
import { groupData } from "../components/nestedtab/friendRequestsData";
import pipaanlogo from "../assets/pipaanlogo.svg";
import closecircle from "../assets/images/icons/close-circle.png";
import { Swiper, SwiperSlide } from "swiper/react";
// import { uploadFiles } from "../../src/utils/uploadMedia"; // Adjust the path as needed
import Donationbanner from "../assets/images/donation-banner.png";
import userimg from "../assets/user.png";
import StoryBar from "../components/story/StoryBar";
import PostVideo from "./common/PostVideo";
import PostSound from "./common/PostSound";
import { toast } from "react-toastify";
// import { Picker } from "emoji-mart";
// import "emoji-mart/css/emoji-mart.css"; // Import emoji-mart styles
import ShareModal from "../components/ShareModal"; // adjust path accordingly
import { formatDateTime } from "../utils/date"; // Adjust the path as necessary
import { connectSocket } from "../utils/socketClient";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

import { fetchOwnProfile, getUser } from "../utils/auth";
const APP_BASE_URL = (process.env.REACT_APP_APP_BASE_URL || "").replace(/\/$/, "");
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// Fallback refresh of the live users row; followed users going live also refresh it in real time
const LIVE_USERS_REFRESH_MS = 60000;
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
// 👇 Add this ProgressBar component inside the same file
// A donation before its start date is "upcoming" and can't receive donations yet
const isUpcomingDonation = (donation) => {
  if (!donation) return false;
  if (donation.donation_status) return donation.donation_status === "upcoming";
  if (!donation.start_date) return false;
  const now = new Date();
  const todayLocal = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  return String(donation.start_date).slice(0, 10) > todayLocal;
};

const formatDonationStart = (donation) =>
  donation?.start_date
    ? new Date(donation.start_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "";

function ProgressBar({ current, max, percentage, donatorsCount, daysLeft }) {
  return (
    <div className="max-w-screen-lg w-full mt-2">
      <div className="flex justify-between text-[500] text-[12px] mb-2">
        <p className="text-[#141414] font-[500]">
          ${current}
          <span className="text-[#666666] font-[500]"> from ${max}</span>
        </p>
      </div>
      <div className="w-auto bg-[#CCCCCC] rounded-full h-2 relative overflow-hidden max-w-[500px]">
        <div
          className="bg-[#077734] h-2 rounded-full flex items-center px-2 text-white text-sm font-semibold"
          style={{ width: `${percentage}%` }}
        >
          {/* ${current}3 */}
        </div>
        {/* <div
                    className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 bg-green-900 rounded-full"
                    style={{ left: `calc(${percentage}% - 8px)` }}
                /> */}
      </div>
      <div className="flex justify-between text-[500] text-[12px] my-2  max-w-[500px]">
        <p className="text-[#141414] font-[500]">
          {/* {donatorsCount} */}
          <span className="text-[#666666] font-[400]">
            <b className="text-[#000]">{donatorsCount}</b> Donors
          </span>
        </p>
        <p className="text-[#141414] font-[500]">
          {/* {current} */}
          <span className="text-[#666666] font-[400]">
            <b className="text-[#000]">{daysLeft}</b> days left
          </span>
        </p>
      </div>
    </div>
  );
}
export default function HomePage(post) {
  // State for selected post data
  const [selectedPostData, setSelectedPostData] = useState(null);

  const [ellipsisMenuOpen, setEllipsisMenuOpen] = useState(false);
  const [donationDescription, setDonationDescription] = useState("");

  const [expandedPosts, setExpandedPosts] = useState(
    Array(profileData?.length).fill(false),
  ); // Ensure consistent hook call
  // ✅ Define state properly
  const [playingIndex, setPlayingIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate(); // Navigation hook
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false); // ✅ Handle loading state
  const [content, setContent] = useState(""); // ✅ Store post content
  const [mediaUrl, setMediaUrl] = useState(""); // ✅ Store media URL (if any)
  const [error, setError] = useState(null);
  // ✅ State to store the posts
  const [posts, setPosts] = useState([]);
  const [noGroups, setNoGroups] = useState(false); // Groups tab: user belongs to no group/family
  const [hasMore, setHasMore] = useState(true); // ✅ Flag to track if there are more posts
  const [page, setPage] = useState(1); // ✅ Track current page
  const loader = useRef(null); // ✅ Ref to observe the scroll position
  const [expandedComments, setExpandedComments] = useState({}); // Track visibility of comment sections
  const [likedUsers, setLikedUsers] = useState([]); // State to store users who liked a post
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [likedUsersPopupPosition, setLikedUsersPopupPosition] = useState(null); // Position the "Users who liked this post" popup near the like button that opened it
  const [selectedPostId, setSelectedPostId] = useState(null); // Track the post ID for the modal
  const { id } = useParams();

  const location = useLocation();

  const POPUP_WIDTH = 448; // matches the popup's max-w-md
  const POPUP_MAX_HEIGHT = 400;
  const POPUP_MARGIN = 8;

  // Anchor the "Users who liked this post" popup near the clicked like button,
  // but clamp it so it always stays fully within the viewport.
  const getClampedPopupPosition = (rect) => {
    const maxLeft = window.innerWidth - POPUP_WIDTH - POPUP_MARGIN;
    const maxTop = window.innerHeight - POPUP_MAX_HEIGHT - POPUP_MARGIN;
    return {
      top: Math.max(POPUP_MARGIN, Math.min(rect.bottom + 8, maxTop)),
      left: Math.max(POPUP_MARGIN, Math.min(rect.left, maxLeft)),
    };
  };

  // Prevent background scroll while the like-popup is open so it doesn't
  // appear to float over shifting content behind it. Both html and body are
  // locked since this app's page scroll happens on the <html> element.
  useEffect(() => {
    document.documentElement.style.overflow = isModalOpen ? "hidden" : "";
    document.body.style.overflow = isModalOpen ? "hidden" : "";
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [isModalOpen]);

  const [longPressTimeout, setLongPressTimeout] = useState(null); // Timeout for long press
  const [commentInputs, setCommentInputs] = useState({}); // State to store comment inputs for each post
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false); // Modal state for comments
  const [comments, setComments] = useState([]); // State to store comments
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [hasMoreUsers, setHasMoreUsers] = useState(true); // Whether more users are available
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [showDonationPopup, setShowDonationPopup] = useState(false);
  const [donators, setDonators] = useState([]);
  const [donatorsLoading, setDonatorsLoading] = useState(false);
  const [donatorsCount, setDonatorsCount] = useState(0); // ✅ Add this
  const [mainTab, setMainTab] = useState("groups"); // main page tab

  const [profiles, setProfiles] = useState([
    {
      id: 1,
      name: "John Doe",
      avatar: "https://via.placeholder.com/50",
      link: "/profile/1",
    },
    {
      id: 2,
      name: "Jane Smith",
      avatar: "https://via.placeholder.com/50",
      link: "/profile/2",
    },
    {
      id: 3,
      name: "Tech Group",
      avatar: "https://via.placeholder.com/50",
      link: "/group/tech",
    },
  ]);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [followerFollowStatus, setFollowerFollowStatus] = useState({}); // Track follow status for followers
  const [followedUsers, setFollowedUsers] = useState({}); // ✅ Track clicked users
  const [followersTotal, setFollowersTotal] = useState(0); // ✅ Total followers count
  const [followingsTotal, setFollowingsTotal] = useState(0); // ✅ Total followings count
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded files
  const [filePreviews, setFilePreviews] = useState([]); // Store file previews
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [donationPosts, setDonationPosts] = useState([]);
  const [showDonateNowPopup, setShowDonateNowPopup] = useState(false);
  const [selectedDonationForNow, setSelectedDonationForNow] = useState(null);

  // Inside your component
  const emojiPickerRef = useRef(null);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentPostUrl, setCurrentPostUrl] = useState("");
  const [activeLives, setActiveLives] = useState([]); // ✅ Active Live Users State
  const isPostRoute = location.pathname.startsWith("/post/");
  const isDonationRoute = location.pathname.startsWith("/donation/");

  const handleShareClick = (shareUrl) => {
    setCurrentPostUrl(shareUrl || `${APP_BASE_URL || window.location.origin}${window.location.pathname}${window.location.search}`);
    setIsShareModalOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false); // ❌ Close if clicked outside
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  // const calculateDaysLeft = (startDate, endDate) => {
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   const diffTime = end - start;
  //   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  //   return diffDays > 0 ? diffDays : 0;
  // };

  const calculateDaysLeft = (endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time part
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };
  const latestDonatorsPostRef = useRef(null);
  const fetchDonators = async (postId) => {
    if (!postId) return; // only ever load donors for a specific campaign
    latestDonatorsPostRef.current = postId;
    setDonatorsLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/donator/get-donators`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
          },
          body: JSON.stringify({
            filters: { post_id: postId }, // ✅ Pass post_id here
            page: 1,
            limit: 100,
          }),
        },
      );
      const data = await response.json();
      const donatorsList = data.result?.donators || [];
      // A slower response for a previously opened campaign must not overwrite the current one
      if (latestDonatorsPostRef.current !== postId) return;
      setDonators(donatorsList);
      setDonatorsCount(donatorsList?.length); // ✅ Store the count
      console.log("Donator Count:", donatorsList?.length);
    } catch (err) {
      console.error("Error fetching donators", err);
      setDonators([]);
      setDonatorsCount(0);
    } finally {
      setDonatorsLoading(false);
    }
  };


  // Called by PostDonatePanel after a successful donation (card donations are recorded by the webhook a little later)
  const refreshAfterDonation = (postId, amount, refreshDelay) => {
    setTimeout(() => {
      if (postId) {
        fetchPostById(postId);
        fetchDonators(postId);
      }
      // Update the donation card totals in the feed behind the popup
      setPosts((prev) =>
        prev.map((p) =>
          p.id === postId
            ? {
                ...p,
                totalDonatedAmount: Number(p.totalDonatedAmount || 0) + Number(amount),
              }
            : p,
        ),
      );
    }, refreshDelay);
  };
  // const fetchDonationPosts = async () => {
  //   const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  //   const userId = sessionStorage.getItem("userID");

  //   if (!token || !userId) {
  //     console.error("Token or user ID is missing.");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/post/get-posts`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           token: token,
  //         },
  //         body: JSON.stringify({
  //           filters: {
  //             user_id: parseInt(userId),
  //             friend_only: true,
  //             media_type: "", // or "image"/"video" if you want to filter
  //           },
  //           page: 1,
  //           limit: 30,
  //         }),
  //       }
  //     );

  //     const result = await response.json();

  //     if (result.success && result.result?.posts??.length > 0) {
  //       const donationsOnly = result.result.posts.filter(
  //         (post) => post.is_donation === true
  //       );
  //       setDonationPosts(donationsOnly);
  //       console.log("Donation Posts:", donationsOnly); // Debugging log
  //     } else {
  //       console.warn("No donation posts found.");
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch donation posts:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchDonationPosts();
  // }, []);

  const currentUserId = Number(
    sessionStorage.getItem("userID") || localStorage.getItem("userID"),
  );
  const [followStatus, setFollowStatus] = useState(null); // 🆕 state to track button label

  // Function to handle post selection
  const handlePostSelection = (postId) => {
    setSelectedPostId(postId); // Set the selected post ID
  };

  // Find the selected post based on the selectedPostId
  // const selectedPost = posts.find((post) => post.id === selectedPostId);

  // Converts URLs in text to clickable links
  function linkify(text) {
    // Handle null/undefined content gracefully
    if (!text) return "";
    text = String(text);

    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = urlRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      let url = match[0];
      let href = url.startsWith("http") ? url : "https://" + url;
      parts.push(
        <a
          key={key++}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          {url}
        </a>,
      );
      lastIndex = urlRegex.lastIndex;
    }
    if (lastIndex < text?.length) {
      parts.push(text?.substring(lastIndex));
    }
    return parts;
  }
  // Function to fetch user profile and navigate to myprofile page
  const handleUsernameClick = async (userId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) {
      alert("You must be logged in to view the profile.");
      return;
    }

    try {
      // Fetch user profile using the API
      const response = await axios.get(
        `${API_BASE_URL}/user/profile?id=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        console.log("User profile fetched successfully:", response.data.result);

        // Redirect to the myprofile page with the user ID
        navigate(`/myprofile/${userId}`);
      } else {
        console.error("Failed to fetch user profile:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  // ✅ Fetch Followings
  const fetchFollowings = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    const userID = sessionStorage.getItem("userID");

    try {
      const response = await fetch(
        `${API_BASE_URL}/friend/get-friends`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
          body: JSON.stringify({
            filters: { allFollowings: true },
            page: 1,
            limit: 10,
          }),
        },
      );

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      console.log("Followings Response:", data.result); // ✅ Debugging log

      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user2IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User2.id; // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      localStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      // ✅ Ensure you're extracting the correct total count
      const totalFollowings = data.result.total || 0;
      setFollowingsTotal(totalFollowings);
      const formattedFollowings = data.result.friends.map((friend) => ({
        id: friend.id,
        friend_id: friend.id,
        first_name: friend.User2.first_name,
        user2id: friend.User2.id,

        username: friend.User2.username,
        profile_picture_url: friend.User2.profile_picture_url || userimg,
        mutualFriendsCount: friend.mutualFriendsCount || 0,
      }));
      console.log("formattedFollowings::", formattedFollowings);
      setFollowings(formattedFollowings);
    } catch (error) {
      console.error("Error fetching followings:", error);
    }
  };
  const saved = localStorage.getItem("groupMessages");
  // ✅ Fetch Followers
  const fetchFollowers = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    // const userID = sessionStorage.getItem("userID");

    const userID = sessionStorage.getItem("userID");
    try {
      const response = await fetch(
        `${API_BASE_URL}/friend/get-friends`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
          body: JSON.stringify({
            filters: { allFollowers: true },
            page: 1,
            limit: 10,
          }),
        },
      );

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user1IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User1.id; // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user1IdMap", JSON.stringify(user1IdMap));
      localStorage.setItem("user1IdMap", JSON.stringify(user1IdMap));
      // ✅ Extract the `total` value for correct count
      setFollowersTotal(data.result.total);
      const formattedFollowers = data.result.friends.map((friend) => {
        const user1id = friend.User1.id;

        // ✅ Store user1id in sessionStorage
        sessionStorage.setItem(`user1id_${friend.friend_id}`, user1id);
        localStorage.setItem(`user1id_${friend.friend_id}`, user1id);

        return {
          id: friend.id,
          friend_id: friend.id,
          user1id: user1id, // Store user1id
          first_name: friend.User1.first_name,
          username: friend.User1.username,
          profile_picture_url: friend.User1.profile_picture_url || userimg,
          mutualFriendsCount: friend.mutualFriendsCount || 0,
          user1FollowersCount: friend.user1FollowersCount || 0,
          myStatus: friend.myStatus, // ✅ Store myStatus
          friendStatus: friend.friendStatus, // ✅ Store friendStatus
        };
      });

      console.log("formattedFollowers :", formattedFollowers);

      setFollowers(formattedFollowers);
    } catch (error) {
      console.error("Error fetching followers:", error);
    }
  };

  // ✅ Fetch Active Live Users
  const fetchActiveLiveUsers = async () => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return;

    try {
      // Friends' donation lives and sellers' live shopping
      const responses = await Promise.all(
        ["filter=friends&stream_type=donation", "filter=sellers&stream_type=marketplace"].map((query) =>
          fetch(`${API_BASE_URL}/live/active-users?${query}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
          }).then((response) => response.json()),
        ),
      );
      // Without the viewer's own live, each live once
      const me = Number(getUser()?.id);
      const streams = responses.flatMap((data) => data?.result?.streams || []).filter((stream) => Number(stream.user?.id) !== me);
      setActiveLives(streams.filter((stream, index) => streams.findIndex((s) => s.stream_id === stream.stream_id) === index));
    } catch (error) {
      console.error("Error fetching active lives:", error);
    }
  };

  useEffect(() => {
    fetchActiveLiveUsers();
    // A followed user going live sends a live_alert notification to this user's personal room
    const socket = connectSocket();
    const joinOwnRoom = () => socket.emit("join", getUser()?.id);
    const onNotification = (notification) => notification?.type === "live_alert" && fetchActiveLiveUsers();
    joinOwnRoom();
    socket.on("connect", joinOwnRoom);
    socket.on("notification", onNotification);
    const timer = setInterval(fetchActiveLiveUsers, LIVE_USERS_REFRESH_MS);
    return () => {
      socket.off("connect", joinOwnRoom);
      socket.off("notification", onNotification);
      clearInterval(timer);
    };
  }, []);

  const handleFollowerAction = async (friendId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Get `user1id` from state instead of sessionStorage
    const user = followers.find((f) => f.id === friendId);
    if (!user || !user.user1id) {
      console.error("User1 ID not found.");
      return;
    }

    console.log("UserID being sent:", user.user1id); // ✅ Debugging log

    try {
      const response = await fetch(
        `${API_BASE_URL}/friend/add-friend`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${token}`,
          },
          body: JSON.stringify({
            status: "pending", // ✅ Use "unfollow" status
            user_id: user.user1id,
          }),
        },
      );

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      // Update follow status in state
      setFollowerFollowStatus((prev) => ({
        ...prev,
        [friendId]: true, // Mark the user as followed
      }));

      // Refresh followers and followings lists
      fetchFollowers();
      fetchFollowings();
    } catch (error) {
      console.error("Error handling follower action:", error);
    }
  };
  useEffect(() => {
    if (searchQuery?.length >= 3) {
      const filteredResults = profiles.filter((profile) =>
        profile.name.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, profiles]);

  // const token =   sessionStorage.setItem("accessToken", accessToken);
  // console.log("Stored Token in homepage:", sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"));
  useEffect(() => {
    // console.log("Checking stored token:", localStorage.getItem("accessToken"));
  }, []);

  // Function to toggle comment section visibility
  const toggleCommentSection = (postId) => {
    setExpandedComments((prev) => ({
      ...prev,
      [postId]: !prev[postId], // Toggle visibility for the specific post
    }));
    // Open the comments modal
    fetchComments(postId); // Fetch comments for the post
  };
  // Function to fetch comments for a post
  const fetchComments = async (postId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view comments.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/get-comments`,
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: 1,
          limit: 40,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        // Map the API response to match the UI structure
        const formattedComments = response.data.result.comments
          .filter((comment) => comment.is_deleted !== true) // ✅ REMOVE deleted comments
          .map((comment) => ({
            id: comment.id,
            name: `${comment.user.first_name} ${comment.user.last_name}`,
            avatar: comment.user.profile_picture_url || profileimg,
            text: comment.content,
            time: formatDateTime(comment.created_at),
            likes: parseInt(comment.totalLikes, 10),
            replies: [],
            isLiked: comment.isLiked,
            post_id: comment.post_id,
            is_deleted: comment.is_deleted, // optional: track for debug
            media: comment.media_url || [], // ✅ Include media array
          }));

        console.log("Formatted Comments:", formattedComments); // Debugging log
        setComments(formattedComments); // Update the comments state
        setSelectedPostId(postId); // Track the post ID
        setIsCommentsModalOpen(true); // Open the modal
      } else {
        console.error("Failed to fetch comments:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };
  useEffect(() => {
    console.log("Updated Comments State:", comments);
  }, [comments]);
  useEffect(() => {
    const fetchData = async () => {
      await fetchFollowers(setFollowers); // Fetch followers and update state
      await fetchFollowings(setFollowings); // Fetch followings and update state
    };

    fetchData();
  }, []);

  const fetchReplies = async (commentId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view replies.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/get-comments`,
        {
          filters: { parent_id: commentId }, // Fetch replies for the specific comment
          page: 1,
          limit: 40,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        const replies = response.data.result.comments.map((reply) => ({
          id: reply.id,
          name: `${reply.user.first_name} ${reply.user.last_name}`,
          avatar: reply.user.profile_picture_url || profileimg,
          text: reply.content,
          time: formatDateTime(reply.created_at),
          likes: parseInt(reply.totalLikes, 10),
          isLiked: reply.isLiked,
          post_id: reply.post_id, // ✅ ADD THIS
        }));

        // Update the replies for the specific comment without duplicating
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? {
                  ...comment,
                  replies: [
                    ...comment.replies.filter(
                      (existingReply) =>
                        !replies.some(
                          (newReply) => newReply.id === existingReply.id,
                        ),
                    ), // Keep only unique replies
                    ...replies,
                  ],
                }
              : comment,
          ),
        );
      } else {
        console.error("Failed to fetch replies:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newMedia = files.map((file) => ({
      file: file, // Store the actual file
      type: file.type.startsWith("image/") ? "image" : "video",
      url: URL.createObjectURL(file), // Generate a preview URL
    }));

    setUploadedMedia((prev) => [...prev, ...newMedia]);
    console.log("New Media Added:", newMedia); // Debugging log
  };

  // Function to cancel long press
  const handleCommentLongPressEnd = () => {
    clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
  };

  // Function to close the comments modal
  const closeCommentsModal = () => {
    setIsCommentsModalOpen(false);
    setComments([]);
  };
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // ✅ Retrieve both tokens and user data
    const emailToken =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    const mobileToken = sessionStorage.getItem("accessTokenMobile");

    const emailUser =
      sessionStorage.getItem("user") || localStorage.getItem("user");
    const mobileUser = sessionStorage.getItem("usermobile");

    // ✅ Use mobile token if available, otherwise fallback to email token
    const activeToken = mobileToken || emailToken;
    const activeUser = mobileUser
      ? JSON.parse(mobileUser)
      : emailUser
        ? JSON.parse(emailUser)
        : null;

    if (activeToken) {
      setToken(activeToken);
    }

    if (activeUser) {
      setUser(activeUser);
    } else {
      navigate("/login"); // Redirect to login if no valid session
    }

    console.log("Active Token:", activeToken);
    console.log("Active User:", activeUser);
  }, [navigate]);

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Retrieve user from login
    const storedUser =
      sessionStorage.getItem("user") || localStorage.getItem("user");
    // Retrieve userDoc from password reset
    const storedUserDoc = sessionStorage.getItem("userDoc");

    // ✅ If user exists from login, use it; otherwise, use userDoc from password reset
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    } else if (storedUserDoc) {
      setUserData(JSON.parse(storedUserDoc));
    }
  }, []);

  // ✅ Get User ID from sessionStorage
  const users = JSON.parse(
    sessionStorage.getItem("user") || localStorage.getItem("user"),
  );
  const userId = users ? users.id : null;
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state
  const [activeTab, setActiveTab] = useState("Followers");
  const [isdonatePopupOpen, setIsdonatePopupOpen] = useState(false); // 🔹 Popup state
  const [isdonatenowPopupOpen, setIsdonatenowPopupOpen] = useState(false);
  const [sentMessages, setSentMessages] = useState(
    saved ? JSON.parse(saved) : [],
  );
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Check which type of route it is
    if (location.pathname.startsWith("/post/")) {
      fetchPostById(id); // Fetch post details by ID
      setSelectedPostId(id); // Store ID separately if needed
      setIsPopupOpen(true);
      fetchComments(id); // 🔥 Fetch comments for the selected post
    } else if (location.pathname.startsWith("/donation/")) {
      fetchPostById(id); // Fetch post details by ID
      setSelectedPostId(id); // Store ID separately if needed
      setIsdonatePopupOpen(true);
      setShowDonationPopup(true); // Open the donation popup/modal
      fetchDonators(id); // ✅ Fetch donators for this post
      fetchComments(id); // 🔥 Fetch comments for the selected post
    }
  }, [id, location.pathname]);

  const messagesEndRef = useRef(null);
  const [userEmail, setUserEmail] = useState(null);

  const USER = {
    id: user?.id, // Use the current user's id
    token:
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken"),
    name: user?.name || "User",
  };

  const API_URL =
    `${API_BASE_URL}/group_chat/add-group_chat`;
  const SOCKET_URL = `${API_ORIGIN}/`;

  const sendMessage = async () => {
    if (!message.trim()) return;

    const payload = {
      message: message,
      reciever_id: "22",
      media_url: [],
      is_group_chat: true,
    };

    try {
      const response = await axios.post(API_URL, payload, {
        headers: {
          Token: USER.token,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const newMsg = {
          message: message,
          sender_id: USER.id,
          timestamp: new Date().toISOString(),
          sender_name: userEmail.first_name,
        };

        const updatedMessages = [...sentMessages, newMsg];
        setSentMessages(updatedMessages);

        localStorage.setItem("groupMessages", JSON.stringify(updatedMessages));

        setMessage("");

        if (response.data && response.data.new_field) {
          window.location.reload(); // hard reload
        }
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  // Scroll events fire many times at the bottom of the page; this ref (unlike the `loading`
  // state captured by the scroll listener) blocks a second request for the same page while one is in flight
  const postsRequestRef = useRef(null);
  const activeTabRef = useRef(activeTab);
  activeTabRef.current = activeTab;
  const POSTS_PAGE_SIZE = 30;

  // ✅ Function to fetch posts
  const fetchPosts = async (
    postType = activeTab === "Groups" ? "group" : "friend",
    reset = false,
    pageNum = 1,
  ) => {
    const requestKey = `${postType}:${pageNum}`;
    if (postsRequestRef.current === requestKey || (!hasMore && !reset)) return;
    postsRequestRef.current = requestKey;

    setLoading(true);
    setError(null);

    const emailToken =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    const activeToken = emailToken;

    if (!activeToken) {
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }

    const requestBody = {
      filters: { postType },
      page: pageNum,
      limit: POSTS_PAGE_SIZE,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-posts`,
        {
          method: "POST",
          headers: {
            token: `${activeToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();

      const currentPostType = activeTabRef.current === "Groups" ? "group" : "friend";
      if (currentPostType !== postType) return; // tab changed while this request was in flight

      if (response.ok && data.success) {
        // const newPosts = data.result.posts;
        const newPosts = (data.result.posts || []).map((p) => ({
          ...p,
          content: p.content ?? "",
        }));

        // setPosts(prev => reset ? newPosts : [...prev, ...newPosts]);
        // ✅ Filter out posts already in state to avoid duplicates
        setPosts((prevPosts) => {
          // A reset reload of page 1 (e.g. right after posting) replaces the list so new posts show at the top
          if (reset && pageNum === 1) return newPosts;
          const existingIds = new Set(prevPosts.map((p) => p.id));
          const filtered = newPosts.filter((p) => !existingIds.has(p.id));
          return [...prevPosts, ...filtered];
        });
        setHasMore(newPosts.length === POSTS_PAGE_SIZE);
        setPage(pageNum + 1);
        if (pageNum === 1) {
          setNoGroups(postType === "group" && Boolean(data.result.noGroups));
        }
      } else {
        setError("Failed to fetch posts.");
      }
    } catch (error) {
      setError("An error occurred while fetching posts.");
    } finally {
      if (postsRequestRef.current === requestKey) postsRequestRef.current = null;
      setLoading(false);
    }
  };

  const handleScrollLikedPost = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMoreUsers) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchLikedUsers(selectedPostId, nextPage); // Fetch the next page of users
    }
  };
  // ✅ Scroll event handler
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 100 >=
      document.documentElement.scrollHeight
    ) {
      fetchPosts(activeTab === "Groups" ? "group" : "friend", false, page);
    }
  };

  // ✅ Scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore]);

  // ✅ Infinite Scroll Observer
  const observer = useRef();

  const lastPostRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchPosts(); // Fetch more posts when scrolled to bottom
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore],
  );

  // ✅ Fetch posts on component mount
  useEffect(() => {
    setPosts([]);
    setPage(1);
    setHasMore(true);
    fetchPosts(activeTab === "Groups" ? "group" : "friend", true, 1);
  }, [activeTab]);

  const [likingPosts, setLikingPosts] = useState(new Set()); // track posts being liked

  // Function to handle like action
  const handleLikeClick = async (postId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a post.");
      return;
    }

    // If this post is already being processed, block the click
    if (likingPosts.has(postId)) return;

    // Mark as being liked
    setLikingPosts((prev) => new Set(prev).add(postId));

    // Find the post to check if it's already liked
    const post = posts.find((p) => p.id === postId);
    const isLiked = post?.isLiked; // Add an `isLiked` property to track the like status

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/add-like`,
        { post_id: postId, user_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        console.log("Post liked successfully:", response.data);
        toast.success(
          isLiked ? "Post disliked successfully!" : "Post liked successfully!",
        );
        // window.reload(); // Reload the page to reflect changes
        // Update the like count and `isLiked` status in the UI
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === postId
              ? {
                  ...post,
                  likeCount: isLiked
                    ? Math.max((Number(post.likeCount) || 0) - 1, 0) // Decrease like count
                    : (Number(post.likeCount) || 0) + 1, // Increase like count
                  isLiked: !isLiked, // Toggle the `isLiked` status
                }
              : post,
          ),
        );
      } else {
        console.error("Failed to like/dislike:", response.data.message);
      }
    } catch (error) {
      console.error("Like API error:", error);
    } finally {
      // Remove from tracking so it can be clicked again after operation completes
      setLikingPosts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(postId);
        return newSet;
      });
    }
  };

  const handleCommentLikeClick = async (commentId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a comment.");
      return;
    }

    // const comment = comments.find((c) => c.id === commentId);
    const comment =
      comments.find((c) => c.id === commentId) ||
      comments.flatMap((c) => c.replies || []).find((r) => r.id === commentId);
    const isLiked = comment?.isLiked;
    const postId = comment?.post_id; // ✅ use post_id from the comment object

    if (!postId) {
      console.error("❌ Missing post_id in comment object");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/add-like`,
        {
          post_id: Number(postId),
          comment_id: Number(commentId),
          user_id: Number(userId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        setComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: c.replies?.map((r) =>
              r.id === commentId
                ? {
                    ...r,
                    likes: isLiked
                      ? Math.max((Number(r.likes) || 0) - 1, 0)
                      : (Number(r.likes) || 0) + 1,
                    isLiked: !isLiked,
                  }
                : r,
            ),
            ...(c.id === commentId
              ? {
                  likes: isLiked
                    ? Math.max((Number(c.likes) || 0) - 1, 0)
                    : (Number(c.likes) || 0) + 1,
                  isLiked: !isLiked,
                }
              : {}),
          })),
        );
      } else {
        console.error("Failed to like comment:", response.data.message);
      }
    } catch (error) {
      console.error("Error liking comment:", error);
    }
  };

  // Function to fetch users who liked a post
  const fetchLikedUsers = async (postId, page = 1) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view likes.");
      return;
    }
    // Reset state if fetching for a new post
    if (postId !== selectedPostId) {
      setLikedUsers([]); // Clear previous users
      setCurrentPage(1); // Reset pagination
      setHasMoreUsers(true); // Reset the "has more users" flag
      setSelectedPostId(postId); // Update the selected post ID
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/get-likes`,
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: page,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        console.log("Fetched liked users response:", response.data);
        console.log(
          "Fetched liked users responses:",
          response.data.result.likes,
        );

        // Extract the `user` objects from the `likes` array
        // Extract the `user` objects from the `likes` array
        const users = response.data.result.likes.map((like) => ({
          ...like.user,
        }));
        setLikedUsers((prevUsers) => [...prevUsers, ...users]); // Append new users to the existing list
        setHasMoreUsers(users?.length === 10); // Check if there are more users to load

        // setLikedUsers(users); // Set the extracted users in the state
        // setSelectedPostId(postId);
        setIsModalOpen(true); // Open the modal
      }

      // setSelectedPostId(postId);
      // setIsModalOpen(true);
      else {
        console.error("Failed to fetch liked users:", response.data.message);
        alert("No users found for this post.");
      }
    } catch (error) {
      console.error("Error fetching liked users:", error);
      alert("An error occurred while fetching liked users.");
    }
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setLikedUsers([]);
  };

  const toggleReadMore = (index) => {
    setExpandedPosts((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index]; // Toggle specific post
      return updated;
    });
  };

  const handleFollowClick = async (userId, privacyStatus) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/friend/add-friend`,
        {
          status: "pending",
          user_id: userId,
        },
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.success) {
        console.log("✅ Friend request sent successfully:", response.data);

        // ✅ Update UI dynamically
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.user_id === userId
              ? {
                  ...post,
                  myStatus: privacyStatus === "public" ? "accepted" : "pending", // ✅ Public -> "Following", Private -> "Requested"
                }
              : post,
          ),
        );

        // ✅ Also update the "Users who liked this post" popup list, since its
        // Follow button reads myStatus from likedUsers, not posts
        setLikedUsers((prevUsers) =>
          prevUsers.map((u) =>
            u.id === userId
              ? {
                  ...u,
                  myStatus: privacyStatus === "public" ? "accepted" : "pending",
                }
              : u,
          ),
        );

        // ✅ Also update the open donation popup, since its Follow button
        // reads myStatus from selectedDonation, not posts
        setSelectedDonation((prev) =>
          prev?.user?.id === userId
            ? {
                ...prev,
                myStatus: privacyStatus === "public" ? "accepted" : "pending",
              }
            : prev,
        );
      } else {
        console.error(
          "❌ Failed to send friend request:",
          response.data.message,
        );
      }
    } catch (error) {
      console.error("❌ Error sending friend request:", error);
    }
  };

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const userviewpost = { id: 1 };
  const [activeIndex, setActiveIndex] = useState(0); // Track active slide
  const [zoomLevels, setZoomLevels] = useState({}); // Store zoom levels for each image

  const dummyPost = {
    id: 1,
    user: {
      id: 101,
      username: "Fund For Heart Failure Student",
      date: "27 Jan 2025, 12:30 PM",
      email: "organizer@example.com",
      banner: Donationbanner, // Replace with real image URL
      privacy_status: "public",
    },
    isOwn: false,
    myStatus: null, // can be "accepted", "pending", or null
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    media_url: [
      {
        media_type: "image",
        url: crtpostimg,
      },
      {
        media_type: "image",
        url: crtpostimg,
      },
      {
        media_type: "image",
        url: crtpostimg,
      },
    ],
    location: "New York, USA",
    likeCount: 4300,
    isLiked: true,
    commentCount: 4200,
    viewsCount: 120,
    startDate: "2025-05-18",
    endDate: "2025-05-28",
    raisedAmount: 1500,
    targetAmount: 2000,
    username: "Emergency Fund For Student",
    tags: ["#Donation", "#Help"],

    // ➕ New key: followersList
    followersList: [
      // {
      //   id: 1,
      //   username: "Health Aid Group",
      //   profile_image: "https://example.com/user1.jpg", // Replace with actual image or fallback
      //   followers_count: 1250
      // },
      // {
      //   id: 2,
      //   username: "Community Supporters",
      //   profile_image: "https://example.com/user2.jpg",
      //   followers_count: 980
      // },
      {
        id: 3,
        username: "Medical Donation Team",
        profile_image: "", // Use fallback image in rendering
        followers_date: "27 Jan 2025, 12:30 PM",
      },
    ],
  };

  const imagespost = [
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    // demovideo
  ];
  // const isPlaying = playingIndex === `${index}-${imgIndex}`;
  // Check if the active slide is a video
  const isVideo = imagespost[activeIndex]?.type === "video";
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState([]);
  const [coverPic, setCoverPictureUrl] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      if (!token) {
        console.warn("Token not found");
        return;
      }

      try {
        const response = await fetchOwnProfile(token);

        const data = await response.json();

        if (response.ok && data.result) {
          const profilePic = data.result.profile_picture_url;

          if (profilePic) {
            sessionStorage.setItem("profilePictureUrl", profilePic);
            localStorage.setItem("profilePictureUrl", profilePic);
            setProfilePictureUrl(profilePic);
          }

          if (coverPic) {
            setCoverPictureUrl(coverPic);
          }
        } else {
          console.error("Profile fetch error:", data.message);
        }
      } catch (err) {
        console.error("Network error fetching profile:", err);
      }
    };

    fetchUserProfile();
  }, []);
  // const [selectedPost, setSelectedPost] = useState(null);
  // Filter group data based on user.id
  const selectedGroup = groupData.find((group) => group.id === user?.id);

  const openPopup = (post) => {
    // setSelectedPost(post);
    setSelectedPostId(post.id); // Store ID separately if needed
    setIsPopupOpen(true);
    fetchPostById(post.id); // Fetch post details by ID

    fetchComments(post.id); // 🔥 Fetch comments for the selected post
  };
  const openPopupdonate = (post) => {
    // setSelectedPost(post);
    setZoomLevels({});
    setActiveIndex(0);
    setSelectedDonation(post); // Store the whole post object
    setSelectedDonation(post); // Store the whole post object

    setSelectedPostId(post?.id); // Store ID separately if needed
    setIsdonatePopupOpen(true);
    setShowDonationPopup(true); // Open the donation popup/modal
    setShowDonationPopup(true); // Open the donation popup/modal
    fetchDonators(post.id); // ✅ Fetch donators for this post

    fetchComments(post.id); // 🔥 Fetch comments for the selected post
  };
  const openPopupdonatenow = (post) => {
    // setSelectedPost(post);
    setSelectedPostId(post.id); // Store ID separately if needed
    setIsdonatenowPopupOpen(true);
    fetchComments(post.id); // 🔥 Fetch comments for the selected post
  };

  // const selectedPost = posts.find((p) => p.id === selectedPostId); // lookup
  const [selectedPost, setSelectedPost] = useState(null);
  // Donation popup media: cover (banner_image) first, then any extra media.
  const popupPost = selectedDonation || selectedPost;
  const popupBanner = popupPost?.banner_image?.url
    ? [
        {
          url: popupPost.banner_image.url,
          media_type: String(
            popupPost.banner_image.media_type || popupPost.banner_image.type || "",
          ).startsWith("video")
            ? "video"
            : "image",
        },
      ]
    : [];
  const popupMedia = [...popupBanner, ...(popupPost?.media_url || [])];

  const fetchPostById = async (postId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-post-by-id?id=${postId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token,
          },
        },
      );
      const data = await response.json();
      if (data.success && data.result) {
        setSelectedPost(data.result);
        setSelectedDonation(data.result);
      } else {
        setSelectedPost(null);
        alert("Failed to fetch post details.");
      }
    } catch (error) {
      setSelectedPost(null);
      alert("Error fetching post details.");
    }
  };
  const closePopup = () => {
    setIsPopupOpen(false);
    setIsdonatePopupOpen(false);
    setIsdonatenowPopupOpen(false);
  };

  // Handle sending message
  const handleSendMessage = () => {
    if (message.trim() || images?.length > 0) {
      const currentTime = formatDateTime(new Date());

      setMessages([...messages, { text: message, images, time: currentTime }]);
      setMessage("");
      setImages([]);
    }
  };
  // Handle image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const uploadedImages = files.map((file) => URL.createObjectURL(file));
    setImages([...images, ...uploadedImages]);
  };
  // Zoom In Function (only for active image)
  const zoomIn = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: Math.min((prev[activeIndex] || 1) + 0.2, 2), // Max zoom 2x
    }));
  };

  // Zoom Out Function (reset zoom)
  const zoomOut = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: 1, // Reset to normal size
    }));
  };

  // Function to handle comment input change
  const handleCommentChange = (postId, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [postId]: value, // Update the comment input for the specific post
    }));
  };

  const uploadFiles = async () => {
    if (!uploadedMedia || uploadedMedia?.length === 0) {
      // alert("Please select files");
      toast.info("ℹ️ Please select files to upload.");

      return [];
    }

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
          },
        },
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              "Content-Type": uploadedMedia[index].file.type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        }),
      );

      return preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl, // Extract fileUrl from API response
      }));
    } catch (error) {
      console.error("Upload error:", error);
      setError("Failed to upload files. Please try again.");
      throw new Error("Failed to upload files");
    }
  };

  // Clean up preview URLs when component unmounts
  useEffect(() => {
    return () => {
      uploadedMedia.forEach((media) => {
        URL.revokeObjectURL(media.url);
      });
    };
  }, [uploadedMedia]);
  const [sendingCommentId, setSendingCommentId] = useState(null); // null = not sending

  const handleCommentSubmit = async (postId, content, uploadedMedia) => {
    if (sendingCommentId === postId) return; // Prevent multiple clicks

    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    const user = JSON.parse(
      sessionStorage.getItem("user") || localStorage.getItem("user"),
    ); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    setSendingCommentId(postId); // ✅ Disable send button for this post

    try {
      let mediaPayload = [];
      if (uploadedMedia && uploadedMedia?.length > 0) {
        // Upload files and get the media payload
        mediaPayload = await uploadFiles(uploadedMedia);
      }
      console.log("Media Payload:", mediaPayload); // Debugging log

      const response = await axios.post(
        `${API_BASE_URL}/comment/add-comment`,
        {
          media_url: mediaPayload,
          post_id: postId,
          content: content,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        const newComment = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || profileimg, // Use user's profile picture or default avatar
          text: content,
          time: formatDateTime(response.data.result.created_at),

          likes: 0,
          isLiked: false,
          post_id: postId,
          replies: [],
        };

        setComments((prevComments) => [...prevComments, newComment]); // Add the new comment to the state

        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === postId
              ? {
                  ...post,
                  commentCount: (Number(post.commentCount) || 0) + 1,
                }
              : post,
          ),
        );

        toast.success(" Comment added successfully!");
        setUploadedFiles([]); // Clear uploaded files
        setFilePreviews([]); // Clear file previews

        // Optionally, refresh comments or update the UI
      } else {
        console.error("Failed to add comment:", response.data.message);
        toast.error(response.data.message || "Couldn't add comment");
        return false;
      }
      return true;
      // window.location.reload(); // Reload the page to see the new comment
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error(error.response?.data?.message || "Couldn't add comment");
      return false;
    } finally {
      setSendingCommentId(null); // ✅ Re-enable send button
    }
  };
  const handleRemoveFile = (index) => {
    setUploadedMedia((prev) => prev.filter((_, i) => i !== index)); // Remove file
  };

  const current = dummyPost.raisedAmount;
  const max = dummyPost.targetAmount;
  const percentage = (current / max) * 100;
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsPopupOpen(false);
        navigate("/home"); // return to home feed}
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  return (
    <div className="dashboard w-full min-h-screen  block lg:grid lg:grid-cols-[auto_minmax(0,1fr)]">
      {/* Sidebar */}
      <div className="h-full menu-bar-left">
        <Leftsidebar />
      </div>
      <main className="md:flex-1 min-w-0 p-4 md:p-6 lg:pl-4">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="block lg:grid lg:grid-cols-[78%_20%]">
          {/* Feeds */}
          <div className="lg:pr-4 xl:pr-5">
            <StoryBar
              liveUsers={activeLives.map((stream) => ({
                id: `live-${stream.stream_id}`,
                isLive: true,
                name: stream.user?.seller?.name || stream.user?.first_name || stream.user?.username || "User",
                avatar: stream.user?.profile_picture_url,
                liveStream: stream,
              }))}
              onOpenLive={(stream) => navigate(liveStreamPath(stream))}
            />

            <Createpost posts={posts} fetchPosts={() => fetchPosts(undefined, true, 1)} />

            <div className="feed-tabs w-full mx-auto text-center lg:text-left mt-3">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 md:gap-x-6 justify-between">
                <h2 className="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">
                  Feeds
                </h2>
                <div className="filter bg-[#EBF8ED] lg:p-3 flex shrink-0 space-x-4">
                  {["Groups", "Followers"].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 ${
                        activeTab === tab
                          ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                          : "text-black"
                      } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>

              {/* Tab Content */}
              <div className="mt-4 ">
                {/* {
                  activeTab === "Interests" && (
                    <div>
                      {loading && <p>Loading posts...</p>}
                      <div className="w-full">
                        {posts?.length > 0 ? (
                          posts.map((post, index) => (
                            <div key={index} className="share-content relative">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center" >
                                  <img
                                    src={post.user?.profile_picture_url || profileimg}
                                    alt={post.user?.username || "User"}
                                    className="w-12 h-12 rounded-full mr-4"

                                  />

                                  <div>
                                    <p className="font-bold cursor-pointer text-black-500" onClick={() => handleUsernameClick(post.user?.id)} // Call handleUsernameClick on click
                                    >{post.user?.username || "Unknown User"}</p>
                                    <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p>
                                  </div>
                                  {post.location && (
                                    <div className="mt-2 text-sm text-gray-500">
                                      <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                      {post.location}
                                    </div>
                                  )}
                                </div>

                                {!post.isOwn && (
                                  <button
                                    onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                    className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${post.myStatus === "accepted"
                                      ? "bg-gray-400 text-white" // :white_check_mark: Following
                                      : post.myStatus === "pending"
                                        ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                        : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                    disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // :white_check_mark: Disable after clicking
                                  >
                                    {post.myStatus === "accepted"
                                      ? "Following"
                                      : post.myStatus === "pending"
                                        ? "Requested"
                                        : "Follow"}
                                  </button>
                                )}
                              </div>
                              <button
                                placeholder="Share something..."
                                className=""
                                onClick={openPopup} >
                                <p className="mt-2 text-left">{post.content}</p>

                                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {post?.media_url??.length > 0 && (
                                    post?.media_url?.map((media, mediaIndex) => (
                                      <div key={mediaIndex}>
                                        {media?.media_type === "video" ? (
                                          <PostVideo
                                            src={media?.url}
                                            soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} licenceNeeded={post?.licence_needed}
                                            className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                          />
                                        ) : (
                                          <img
                                            src={media?.url}
                                            alt={`media-${mediaIndex}`}
                                            width="100%"
                                            className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                          />
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>
                              </button>
                              {post?.sound_id && !post?.media_url?.some((m) => m?.media_type === "video") && <PostSound soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} />}
                              <div className="react-social-cta flex justify-between items-center mt-8">
                                <div className="flex space-x-4">
                                  <button className="like flex items-center space-x-1 bg-[#BE1F2E] text-white px-3 py-1">
                                    <img
                                      src={post.isLiked ? Redheart : likeIcon} // Use a filled heart icon if liked
                                      alt="Like"
                                      className="flex items-center space-x-1 px-2 py-1 "
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        handleLikeClick(post.id); // Call handleLikeClick
                                      }}
                                    />

                                    <span
                                      className="cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        const rect = e.currentTarget.getBoundingClientRect();
                                        setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                        fetchLikedUsers(post.id); // Call fetchLikedUsers
                                      }}
                                    >
                                      {post.likeCount}
                                    </span>
                                  </button>

                                  <button
                                    onClick={() => toggleCommentSection(post.id)} // Toggle comment section

                                    className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                    <img src={commentIcon} alt="Comment" className="mr-1 space-x-1 px-2 py-1" /> {post.commentCount}
                                  </button>

                                  <button className="eye flex items-center space-x-1 text-black">
                                    <img src={viewIcon} alt="Views" className="mr-1" /> {post.viewsCount} Views
                                  </button>
                                </div>
                                <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                  <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                </button>
                              </div>
                              {isModalOpen && selectedPostId === post.id && (
                                <div className="fixed inset-0 bg-[#00000005] w-full  z-40">
                                  <div
                                    onScroll={handleScrollLikedPost} // Attach the scroll handler
                                    style={likedUsersPopupPosition ? { position: "fixed", top: likedUsersPopupPosition.top, left: likedUsersPopupPosition.left, maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" } : { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" }}
                                    className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative"
                                    <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                    <ul>
                                      {likedUsers?.length > 0 ? (
                                        likedUsers.map((user, index) => (
                                          <li key={index} className="mb-2 flex items-center justify-between">
                                            <div className="flex items-center min-w-0 flex-1 mr-2">
                                              <img
                                                src={user.profile_picture_url || profileimg}
                                                alt={user.username}
                                                className="w-8 h-8 rounded-full inline-block mr-2"
                                              />
                                              <div className="min-w-0">
                                                <p className="font-bold truncate">{user.username}</p>
                                                <p className="text-sm text-gray-500 break-all">{user.email}</p>
                                              </div>
                                            </div>
                                            {user.id !== currentUserId && ( // prevent showing follow for self
                                              <button
                                                onClick={() => handleFollowClick(user.id, user.privacy_status)}
                                                className={`px-4 py-1 rounded-full flex-shrink-0 whitespace-nowrap ${user.myStatus === "accepted"
                                                  ? "bg-gray-400 text-white" // Following
                                                  : user.myStatus === "pending"
                                                    ? "bg-yellow-500 text-black" // Requested
                                                    : "bg-[#095228] text-white" // Follow
                                                  }`}
                                                disabled={user.myStatus === "pending" || user.myStatus === "accepted"} // Disable if already following or requested
                                              >
                                                {user.myStatus === "accepted"
                                                  ? "Following"
                                                  : user.myStatus === "pending"
                                                    ? "Requested"
                                                    : "Follow"}
                                              </button>
                                            )}
                                          </li>
                                        ))
                                      ) : (
                                        <p>No users found.</p>
                                      )}
                                    </ul>
                                    {hasMoreUsers && <p className="text-center text-gray-500 mt-4">Loading more...</p>}

                                    <button
                                      onClick={closeModal}
                                      className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        maxLength={1000}
                                        onChange={(e) =>
                                          handleCommentChange(post.id, e.target.value)
                                        }
                                        className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex space-x-2">
                                      <button>
                                        <img src={smileyIcon} alt="Smiley" className="w-5 h-5" />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}

                                        />
                                      </label>

                                      <button className="px-3">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                      </button>

                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() => handleRemoveFile(index)}
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">

                                        Send
                                      </button>
                                     
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">Comments</h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                              <p className="text-sm text-gray-500">{comment.content}</p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        )
                          : (
                            <p>No posts available.</p>
                          )}
                      </div>

                    </div>
                  )
                } */}

                {/* {activeTab === "Groups" && <p>👥 Displaying Groups Feed...</p>} */}
                {activeTab === "Groups" && (
                  <div>
                    {/*  */}
                    {loading && <p>Loading posts...</p>}
                    <div className="w-full">
                      {posts?.length > 0 ? (
                        posts.map((post, index) =>
                          post.is_donation ? (
                            <div>
                              <div
                                key={post.id}
                                className="p-4 border-b bg-[#EBF8ED] home-donation-feeds"
                              >
                                <div className="flex items-center">
                                  <img
                                    src={post.banner_image?.url || profileimg}
                                    alt={post.user?.username || "banner"}
                                    className="w-full h-full donation-banner mr-4"
                                  />
                                </div>

                                <button
                                  onClick={() => openPopupdonate(post)}
                                  className="w-full"
                                >
                                  <div className="mt-4 flex gap-3">
                                    {post?.media_url?.length > 0 &&
                                      post.media_url.map(
                                        (media, mediaIndex) => (
                                          <div key={mediaIndex}>
                                            {media.media_type === "video" ? (
                                              <video
                                                src={media.url}
                                                controls
                                                width="58px"
                                                height="57px"
                                                className="rounded-lg"
                                              />
                                            ) : (
                                              <img
                                                src={media.url}
                                                alt={`media-${mediaIndex}`}
                                                width="130px"
                                                height="120px"
                                                className="rounded-lg"
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                  </div>

                                  {post.followersList?.map((group, index) => (
                                    <div
                                      key={index}
                                      className="followers-title-content flex items-center justify-between space-x-4 my-4 mx-5"
                                    >
                                      <div className="flex items-center">
                                        <img
                                          src={group.profile_image || userimg}
                                          alt={group.username}
                                          className="w-12 h-12 rounded-full"
                                        />
                                        <div className="ml-1">
                                          <p className="follower-title-name titlesemibold font-semibold">
                                            {group.username}
                                          </p>
                                          <p className="members text-left text-sm text-gray-500">
                                            {group.followers_date}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="view-sharepost-drpdown">
                                        <button
                                          onClick={toggleDropdown}
                                          className="share-public flex items-center px-2 py-2"
                                        >
                                          <img
                                            src={morecircle}
                                            alt="Globe"
                                            className=""
                                          />
                                        </button>

                                        {isOpen && (
                                          <div className="absolute bg-white shadow-md rounded-md w-40 p-2 right-0">
                                            <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                              Edit
                                            </button>
                                            <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                              Delete
                                            </button>
                                            {/* <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button> */}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}

                                  <div className="flex items-center justify-between my-4 mx-5">
                                    <div className="flex items-center w-full">
                                      <div className="flex items-center justify-between w-full">
                                        <div className="flex items-center justify-start ">
                                          <img
                                            src={profilePictureUrl || profileimg}
                                            alt="Profile"
                                            className="w-10 h-10 rounded-full object-cover"
                                          />
                                          <div className="ml-2 text-left">
                                            <h2
                                              className="font-[600] cursor-pointer text-[14px]"
                                              onClick={(e) => {
                                                e.stopPropagation(); // Prevents the parent button's onClick
                                                handleUsernameClick(
                                                  post.user?.id,
                                                );
                                              }}
                                            >
                                              {post.user?.username ||
                                                "Unknown User"}
                                            </h2>

                                            {/* <p className="text-[12px] text-[#747474CC]">
                                            {post.created_at
                                              ? formatDateTime(post.created_at, { hour12: true })
                                              : "No Date"}
                                          </p> */}
                                          </div>
                                        </div>
                                        <div className="flex items-center justify-end relative">
                                          {/* Ellipsis Button */}
                                          {/* <button
                                          onClick={() =>
                                            setEllipsisMenuOpen(
                                              !ellipsisMenuOpen
                                            )
                                          }
                                          className="p-2 rounded-full hover:bg-gray-100"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 30 30"
                                            fill="none"
                                          >
                                            <path
                                              d="M15 27.5C21.875 27.5 27.5 21.875 27.5 15C27.5 8.125 21.875 2.5 15 2.5C8.125 2.5 2.5 8.125 2.5 15C2.5 21.875 8.125 27.5 15 27.5Z"
                                              stroke="#292D32"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M19.9956 15H20.0068"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M14.9941 15H15.0053"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M9.99313 15H10.0044"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </button> */}

                                          {/* Dropdown Menu */}
                                          {/* {ellipsisMenuOpen && (
                                          <div className="absolute top-8 left-0 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                                            <ul className="py-1 text-sm text-gray-700">
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Edit
                                                </button>
                                              </li>
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Delete
                                                </button>
                                              </li>
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Share
                                                </button>
                                              </li>
                                            </ul>
                                          </div>
                                        )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <h2 className="font-[600] cursor-pointer text-[22px] mx-5 text-left">
                                    {" "}
                                    {post.title ||
                                      post.user?.username ||
                                      "Unknown User"}
                                  </h2>

                                  <div className="text-sm text-[#0F5F1A] flex items-center justify-start mx-5">
                                    <p className="text-[10px] text-[#747474CC] ">
                                      <p className="font-bold cursor-pointer text-black-500">
                                        {post.created_at
                                          ? formatDateTime(post.created_at, {
                                              hour12: true,
                                            })
                                          : "No Date"}
                                      </p>
                                    </p>
                                    &nbsp;|
                                    <div className="flex items-center justify-start">
                                      {post.isPublic === false ? (
                                        <FaLock className="w-[10px] h-[10px] mx-1" />
                                      ) : (
                                        <img
                                          src={greenglobal}
                                          alt=""
                                          className="w-[10px] h-[10px] mx-1"
                                        />
                                      )}
                                      {post.isPublic === false ? "Private" : "Public"}
                                    </div>
                                  </div>
                                  <p
                                    className="mt-3 mx-5 text-[12px] cursor-pointer font-[400] text-left"
                                    onClick={() => {
                                      setSelectedDonation(post);
                                      setShowDonationPopup(true);
                                    }}
                                  >
                                    {linkify(post.content)}
                                  </p>
                                </button>

                                {/* Date and Progress */}
                                <div className="flex items-center justify-between gap-3 p-4 rounded-md w-full my-5 mx-2">
                                  <ProgressBar
                                    donatorsCount={
                                      Number(post.donatorCount) || 0
                                    } // ✅ Use donatorCount from post
                                    daysLeft={calculateDaysLeft(post.end_date)}
                                    current={
                                      Number(post.totalDonatedAmount) || 0
                                    }
                                    max={Number(post.donation_target) || 100}
                                    percentage={
                                      (Number(post.totalDonatedAmount || 0) /
                                        Number(post.donation_target || 1)) *
                                      100
                                    }
                                  />

                                  <div className="w-full max-w-[300px] flex items-center flex-end gap-2">
                                    <img src={calender} alt="Calendar" />
                                    <span className="text-black text-[12px] font-[500] font-poppins">
                                      {new Date(
                                        post.start_date,
                                      ).toLocaleDateString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}{" "}
                                      -{" "}
                                      {new Date(
                                        post.end_date,
                                      ).toLocaleDateString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </span>
                                  </div>
                                </div>

                                {/* Reactions */}
                                <div className="react-social-cta flex justify-between items-center mt-8 mx-5">
                                  <div className="flex space-x-4">
                                    <button
                                      onClick={(e) => {
                                        // Tapping the pill itself (not only the small heart) likes the post; the heart and the count keep their own handlers.
                                        if (e.target === e.currentTarget && !likingPosts.has(post.id)) handleLikeClick(post.id);
                                      }}
                                      className="like flex items-center space-x-1 text-white px-3 py-2"
                                      style={{
                                        background: post.isLiked
                                          ? "#F9E9EA"
                                          : "#BE1F2E",
                                      }}
                                    >
                                      <img
                                        src={
                                          post.isLiked
                                            ? RedlikeIcon
                                            : Whiteheart
                                        }
                                        alt="Like"
                                        // className="flex items-center space-x-1 px-2 py-1 "
                                        disabled={likingPosts.has(post.id)}
                                        onClick={() => handleLikeClick(post.id)}
                                        className={`flex items-center space-x-1 md:px-2 md:py-1 ${
                                          likingPosts.has(post.id)
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                      />
                                      <span
                                        className="cursor-pointer"
                                        style={{
                                          color: post.isLiked
                                            ? "#161F28"
                                            : "#FFFFFF",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                          fetchLikedUsers(post.id);
                                        }}
                                      >
                                        {post.likeCount}
                                      </span>
                                    </button>

                                    <button
                                      onClick={() =>
                                        toggleCommentSection(post.id)
                                      }
                                      className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-2"
                                    >
                                      <img
                                        src={commentIcon}
                                        alt="Comment"
                                        className="mx-1"
                                      />
                                      <span class="cursor-pointer">
                                        {post.commentCount}
                                      </span>
                                    </button>

                                    {/* <button className="eye flex items-center space-x-1 text-black">
                                    <img
                                      src={viewIcon}
                                      alt="Views"
                                      className="mr-1"
                                    />
                                    {post.viewsCount} Views
                                  </button> */}
                                  </div>
                                  <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                    <img src={like} alt="Share" />
                                    &nbsp;{post.contribution || 0}&nbsp;
                                    <span className="hidden md:block">
                                      Contributions
                                    </span>
                                  </button>
                                  <button
                                    className="flex items-center space-x-1 text-[#fff] share-post-cta"
                                    onClick={() =>
                                      handleShareClick(post.share_text)
                                    }
                                  >
                                    <img src={shareIcon} alt="Share" />
                                    &nbsp;
                                    <span className="hidden md:block">
                                      Share
                                    </span>
                                  </button>
                                  {/* Share Modal */}
                                  <ShareModal
                                    isOpen={isShareModalOpen}
                                    onClose={() => setIsShareModalOpen(false)}
                                    shareUrl={currentPostUrl}
                                  />
                                </div>
                              </div>
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true
                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img
                                        src={
                                          post.user?.profile_picture_url ||
                                          profileimg
                                        }
                                        alt="Profile"
                                        className="w-10 h-10 rounded-full object-cover"
                                      />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        maxLength={1000}
                                        onChange={(e) =>
                                          handleCommentChange(
                                            post.id,
                                            e.target.value,
                                          )
                                        }
                                        className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center gap-1">
                                      <button>
                                        <img
                                          src={smileyIcon}
                                          alt="Smiley"
                                          className="w-8 h-5"
                                        />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}
                                        />
                                      </label>

                                      {/* ✅ Video Upload */}
                                      <label className="cursor-pointer">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="video/*"
                                          className="hidden"
                                          onChange={handleFileUpload} // ✅ Can reuse this function
                                        />
                                      </label>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() =>
                                          handleCommentSubmit(
                                            post.id,
                                            commentInputs[post.id],
                                            uploadedMedia,
                                          )
                                        }
                                        disabled={sendingCommentId === post.id}
                                        className={`px-4 py-1 rounded-full ${
                                          sendingCommentId === post.id
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-[#095228] text-white"
                                        }`}
                                      >
                                        {sendingCommentId === post.id
                                          ? "Sending..."
                                          : "Send"}
                                      </button>

                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">
                                          Comments
                                        </h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">
                                                {comment.user?.username ||
                                                  "Unknown User"}
                                              </p>
                                              <p className="text-sm text-gray-500">
                                                {comment.content}
                                              </p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="mb-5">
                              <div
                                key={index}
                                className="share-content relative"
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    <div className="profile-dashboard rounded-full overflow-hidden">
                                      <img
                                        src={
                                          post.user?.profile_picture_url ||
                                          profileimg
                                        }
                                        alt={post.user?.username || "User"}
                                        className="rounded-full object-cover"
                                      />
                                    </div>
                                    <div>
                                      <p
                                        className="text-sm cursor-pointer text-black-500"
                                        onClick={() =>
                                          handleUsernameClick(post.user?.id)
                                        } // Call handleUsernameClick on click
                                      >
                                        {post.user?.username || "Unknown User"}
                                      </p>
                                      <p className="font-bold cursor-pointer text-[#747474CC]">
                                        {post.created_at
                                          ? formatDateTime(post.created_at, {
                                              hour12: true,
                                            })
                                          : "No Date"}
                                      </p>
                                      {/* <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p> */}
                                    </div>
                                    {/* Display Location */}
                                    {post.location && (
                                      <div className="mt-2 text-sm text-gray-500">
                                        <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                        {post.location}
                                      </div>
                                    )}
                                  </div>

                                  {/* :white_check_mark: Conditionally render Follow button */}
                                  {!post.isOwn && (
                                    <button
                                      onClick={() =>
                                        handleFollowClick(
                                          post.user_id,
                                          post.user?.privacy_status,
                                        )
                                      }
                                      className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${
                                        post.myStatus === "accepted"
                                          ? "bg-gray-400 text-white" // :white_check_mark: Following
                                          : post.myStatus === "pending"
                                            ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                            : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                      disabled={
                                        post.myStatus === "pending" ||
                                        post.myStatus === "accepted"
                                      } // :white_check_mark: Disable after clicking
                                    >
                                      {post.myStatus === "accepted"
                                        ? "Following"
                                        : post.myStatus === "pending"
                                          ? "Requested"
                                          : "Follow"}
                                    </button>
                                  )}
                                </div>
                                <button
                                  placeholder="Share something..."
                                  className=""
                                  // onClick={openPopup}
                                  onClick={() => openPopup(post)}
                                >
                                  {/* <p className="mt-2 text-left">
                                    {linkify(post.content)}
                                  </p> */}
                                  <p className="mt-4 mb-4 text-black text-justify break-all">
                                    {expandedPosts[index]
                                      ? linkify(post.content)
                                      : linkify(
                                          `${post.content?.slice(0, 276)}`,
                                        )}
                                    {post.content?.length > 276 && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); // 🚫 prevent popup
                                          toggleReadMore(index);
                                        }}
                                        className="text-[#095228] italic hover:underline font-semibold ml-2"
                                      >
                                        {expandedPosts[index]
                                          ? "Read Less"
                                          : "Read More"}
                                      </button>
                                    )}
                                  </p>
                                  {/* :white_check_mark: Render Multiple Media Files */}
                                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {post?.media_url?.length > 0 &&
                                      post?.media_url?.map(
                                        (media, mediaIndex) => (
                                          <div key={mediaIndex}>
                                            {media?.media_type === "video" ? (
                                              <PostVideo
                                                src={media?.url}
                                                soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} licenceNeeded={post?.licence_needed}
                                                className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                              />
                                            ) : (
                                              <img
                                                src={media?.url}
                                                alt={`media-${mediaIndex}`}
                                                width="100%"
                                                className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                  </div>
                                </button>
                                {post?.sound_id && !post?.media_url?.some((m) => m?.media_type === "video") && <PostSound soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} />}
                                {/* Social Buttons */}
                                <div className="react-social-cta flex justify-between items-center mt-8">
                                  <div className="flex space-x-4">
                                    <button
                                      onClick={(e) => {
                                        // Tapping the pill itself (not only the small heart) likes the post; the heart and the count keep their own handlers.
                                        if (e.target === e.currentTarget && !likingPosts.has(post.id)) handleLikeClick(post.id);
                                      }}
                                      className="like flex items-center space-x-1 text-white px-3 py-1"
                                      style={{
                                        background: post.isLiked
                                          ? "#F9E9EA"
                                          : "#BE1F2E",
                                      }}
                                    >
                                      {/* Heart Icon: Calls handleLikeClick */}
                                      <img
                                        src={
                                          post.isLiked
                                            ? RedlikeIcon
                                            : Whiteheart
                                        } // Use a filled heart icon if liked
                                        alt="Like"
                                        disabled={likingPosts.has(post.id)}
                                        onClick={() => handleLikeClick(post.id)}
                                        className={`flex items-center space-x-1 px-2 py-1 ${
                                          likingPosts.has(post.id)
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                      />

                                      {/* Like Count: Calls fetchLikedUsers */}
                                      <span
                                        className="cursor-pointer"
                                        style={{
                                          color: post.isLiked
                                            ? "#161F28"
                                            : "#FFFFFF",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation(); // Prevent triggering parent click events
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                          fetchLikedUsers(post.id); // Call fetchLikedUsers
                                        }}
                                      >
                                        {post.likeCount}
                                      </span>
                                    </button>

                                    <button
                                      onClick={() =>
                                        toggleCommentSection(post.id)
                                      } // Toggle comment section
                                      className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1"
                                    >
                                      <img
                                        src={commentIcon}
                                        alt="Comment"
                                        className="flex items-center space-x-1 px-2 py-1 "
                                      />{" "}
                                      {post.commentCount}
                                    </button>

                                    {/* <button className="eye flex items-center space-x-1 text-black">
                                    <img
                                      src={viewIcon}
                                      alt="Views"
                                      className="mr-1"
                                    />{" "}
                                    {post.viewsCount} Views
                                  </button> */}
                                  </div>
                                  <button
                                    className="flex items-center space-x-1 text-[#fff] share-post-cta"
                                    onClick={() =>
                                      handleShareClick(post.share_text)
                                    }
                                  >
                                    <img src={shareIcon} alt="Share" />
                                    &nbsp;
                                    <span className="hidden md:block">
                                      Share
                                    </span>
                                  </button>
                                  {/* Share Modal */}
                                  <ShareModal
                                    isOpen={isShareModalOpen}
                                    onClose={() => setIsShareModalOpen(false)}
                                    shareUrl={currentPostUrl}
                                  />
                                </div>
                                {/* Popup for Liked Users */}
                                {isModalOpen && selectedPostId === post.id && (
                                  <div className="fixed inset-0 bg-[#00000005] w-full  z-40">
                                    <div
                                      onScroll={handleScrollLikedPost} // Attach the scroll handler
                                      style={likedUsersPopupPosition ? { position: "fixed", top: likedUsersPopupPosition.top, left: likedUsersPopupPosition.left, maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" } : { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" }}
                                      className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative"
                                    >
                                      <h2 className="text-xl font-bold mb-4">
                                        Users who liked this post
                                      </h2>
                                      <ul>
                                        {likedUsers?.length > 0 ? (
                                          likedUsers.map((user, index) => (
                                            <li
                                              key={index}
                                              className="mb-2 flex items-center justify-between"
                                            >
                                              <div className="flex items-center min-w-0 flex-1 mr-2">
                                                <img
                                                  src={
                                                    user.profile_picture_url ||
                                                    profileimg
                                                  }
                                                  alt={user.username}
                                                  className="w-8 h-8 rounded-full inline-block mr-2"
                                                />
                                                <div className="min-w-0">
                                                  <p className="font-bold truncate">
                                                    {user.username}
                                                  </p>
                                                  <p className="text-sm text-gray-500 break-all">
                                                    {user.email}
                                                  </p>
                                                </div>
                                              </div>
                                              {user.id !== currentUserId && ( // prevent showing follow for self
                                                <button
                                                  onClick={() =>
                                                    handleFollowClick(
                                                      user.id,
                                                      user.privacy_status,
                                                    )
                                                  }
                                                  className={`px-4 py-1 rounded-full flex-shrink-0 whitespace-nowrap ${
                                                    user.myStatus === "accepted"
                                                      ? "bg-gray-400 text-white" // Following
                                                      : user.myStatus ===
                                                          "pending"
                                                        ? "bg-yellow-500 text-black" // Requested
                                                        : "bg-[#095228] text-white" // Follow
                                                  }`}
                                                  disabled={
                                                    user.myStatus === "pending" ||
                                                    user.myStatus === "accepted"
                                                  } // Disable if already following or requested
                                                >
                                                  {user.myStatus === "accepted"
                                                    ? "Following"
                                                    : user.myStatus === "pending"
                                                      ? "Requested"
                                                      : "Follow"}
                                                </button>
                                              )}
                                            </li>
                                          ))
                                        ) : (
                                          <p>No users found.</p>
                                        )}
                                      </ul>
                                      {hasMoreUsers && (
                                        <p className="text-center text-gray-500 mt-4">
                                          Loading more...
                                        </p>
                                      )}

                                      <button
                                        onClick={closeModal}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              {/* Comment Section */}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true
                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img
                                        src={
                                          post.user?.profile_picture_url ||
                                          profileimg
                                        }
                                        alt="Profile"
                                        className="w-10 h-10 rounded-full object-cover"
                                      />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        maxLength={1000}
                                        onChange={(e) =>
                                          handleCommentChange(
                                            post.id,
                                            e.target.value,
                                          )
                                        }
                                        className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center gap-1">
                                      <button>
                                        <img
                                          src={smileyIcon}
                                          alt="Smiley"
                                          className="w-8 h-5"
                                        />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}
                                        />
                                      </label>

                                      {/* ✅ Video Upload */}
                                      <label className="cursor-pointer">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="video/*"
                                          className="hidden"
                                          onChange={handleFileUpload} // ✅ Can reuse this function
                                        />
                                      </label>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() =>
                                          handleCommentSubmit(
                                            post.id,
                                            commentInputs[post.id],
                                            uploadedMedia,
                                          )
                                        }
                                        disabled={sendingCommentId === post.id}
                                        className={`px-4 py-1 rounded-full ${
                                          sendingCommentId === post.id
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-[#095228] text-white"
                                        }`}
                                      >
                                        {sendingCommentId === post.id
                                          ? "Sending..."
                                          : "Send"}
                                      </button>

                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">
                                          Comments
                                        </h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">
                                                {comment.user?.username ||
                                                  "Unknown User"}
                                              </p>
                                              <p className="text-sm text-gray-500">
                                                {comment.content}
                                              </p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <p className="py-10 text-center text-gray-500">
                          {noGroups
                            ? "Join a group to see its posts here."
                            : "No posts from your groups yet."}
                        </p>
                      )}
                    </div>

                    {/* <div className="w-full">
                      {donationPosts?.length > 0 ? (
                        donationPosts.map((post, index) => (
                          <div
                            key={post.id}
                            className="p-4 border-b bg-[#EBF8ED] home-donation-feeds"
                          >
                            <div className="flex items-center">
                              <img
                                src={post.banner_image?.url || profileimg}
                                alt={post.user?.username || "banner"}
                                className="w-full h-full donation-banner mr-4"
                              />
                            </div>

                            <button
                              onClick={() => openPopupdonate(post)}
                              className=""
                            >
                              <div className="mt-4 flex gap-3">
                                {post?.media_url?.length > 0 &&
                                  post.media_url.map((media, mediaIndex) => (
                                    <div key={mediaIndex}>
                                      {media.media_type === "video" ? (
                                        <video
                                          src={media.url}
                                          controls
                                          width="58px"
                                          height="57px"
                                          className="rounded-lg"
                                        />
                                      ) : (
                                        <img
                                          src={media.url}
                                          alt={`media-${mediaIndex}`}
                                          width="130px"
                                          height="120px"
                                          className="rounded-lg"
                                        />
                                      )}
                                    </div>
                                  ))}
                              </div>

                              {post.followersList?.map((group, index) => (
                                <div
                                  key={index}
                                  className="followers-title-content flex items-center justify-between space-x-4 my-4 mx-5"
                                >
                                  <div className="flex items-center">
                                    <img
                                      src={group.profile_image || userimg}
                                      alt={group.username}
                                      className="w-12 h-12 rounded-full"
                                    />
                                    <div className="ml-1">
                                      <p className="follower-title-name titlesemibold font-semibold">
                                        {group.username}
                                      </p>
                                      <p className="members text-left text-sm text-gray-500">
                                        {group.followers_date}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="view-sharepost-drpdown">
                                    <button
                                      onClick={toggleDropdown}
                                      className="share-public flex items-center px-2 py-2"
                                    >
                                      <img
                                        src={morecircle}
                                        alt="Globe"
                                        className=""
                                      />
                                    </button>

                                    {isOpen && (
                                      <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                                        <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                          Option 1
                                        </button>
                                        <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                          Option 2
                                        </button>
                                        <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                          Option 3
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}

                              <div className="flex items-center justify-between my-4 mx-5">
                                <div className="flex items-center">
                                  <div>
                                    <h2
                                      className="font-[600] cursor-pointer text-[22px]"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevents the parent button's onClick
                                        handleUsernameClick(post.user?.id);
                                      }}
                                    >
                                      {post.user?.username || "Unknown User"}
                                      <p className="text-sm text-gray-500">
                                        {post.created_at
                                          ? formatDateTime(post.created_at)
                                          : "No Date"}
                                      </p>
                                      {post.title ||
                                        post.user?.username ||
                                        "Unknown User"}
                                    </h2>
                                    <div className="flex items-center justify-start">
                                      <div className="text-sm text-[#0F5F1A] flex items-center justify-start ml-1">
                                        {post.isPublic === false ? (
                                          <FaLock className="w-[10px] h-[10px] mx-1" />
                                        ) : (
                                          <img
                                            src={greenglobal}
                                            alt=""
                                            className="w-[10px] h-[10px] mx-1"
                                          />
                                        )}
                                        {post.isPublic === false ? "Private" : "Public"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <p
                                className="mt-2 mx-5 text-left cursor-pointer"
                                onClick={() => {
                                  setSelectedDonation(post);
                                  setShowDonationPopup(true);
                                }}
                              >
                                {linkify(post.content)}
                              </p>
                              <p className="text-sm text-gray-500">
                                {post.created_at
                                  ? formatDateTime(post.created_at)
                                  : "No Date"}
                              </p>
                              {post.title ||
                                post.user?.username ||
                                "Unknown User"}
                            </button>

                            <div className="flex items-center justify-between gap-3 p-4 rounded-md w-full my-5 mx-2">
                              <ProgressBar
                                donatorsCount={donatorsCount} // ✅ Pass it here
                                daysLeft={calculateDaysLeft(
                                  post.start_date,
                                  post.end_date
                                )}
                                current={Number(post.totalDonatedAmount) || 0}
                                max={Number(post.donation_target) || 100}
                                percentage={
                                  (Number(post.totalDonatedAmount || 0) /
                                    Number(post.donation_target || 1)) *
                                  100
                                }
                              />

                              <div className="max-w-[550px] w-full flex items-center gap-2">
                                <img src={calender} alt="Calendar" />
                                <span className="text-black font-medium">
                                  {new Date(post.start_date).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )}{" "}
                                  -{" "}
                                  {new Date(post.end_date).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="react-social-cta flex justify-between items-center mt-8 mx-5">
                              <div className="flex space-x-4">
                                <button
                                  onClick={(e) => {
                                    // Tapping the pill itself (not only the small heart) likes the post; the heart and the count keep their own handlers.
                                    if (e.target === e.currentTarget && !likingPosts.has(post.id)) handleLikeClick(post.id);
                                  }}
                                  className="like flex items-center space-x-1 text-white px-3 py-1"
                                  style={{
                                    background: post.isLiked
                                      ? "#F9E9EA"
                                      : "#BE1F2E",
                                  }}
                                >
                                  <img
                                    src={
                                      post.isLiked ? RedlikeIcon : Whiteheart
                                    }
                                    alt="Like"
                                    disabled={likingPosts.has(post.id)}
                                    onClick={() => handleLikeClick(post.id)}
                                    className={`like flex items-center space-x-1 px-2 py-1 ${
                                      likingPosts.has(post.id)
                                        ? "opacity-50 cursor-not-allowed"
                                        : ""
                                    }`}
                                  />
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      color: post.isLiked
                                        ? "#161F28"
                                        : "#FFFFFF",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                      fetchLikedUsers(post.id);
                                    }}
                                  >
                                    {post.likeCount}
                                  </span>
                                </button>

                                <button
                                  onClick={() => toggleCommentSection(post.id)}
                                  className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1"
                                >
                                  <img
                                    src={commentIcon}
                                    alt="Comment"
                                    className="mx-1"
                                  />
                                  {post.commentCount}
                                </button>

                                <button className="eye flex items-center space-x-1 text-black">
                                  <img
                                    src={viewIcon}
                                    alt="Views"
                                    className="mr-1"
                                  />
                                  {post.viewsCount} Views
                                </button>
                              </div>
                              <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                <img src={like} alt="Share" />
                                &nbsp;{post.viewsCount}&nbsp;Contributed
                              </button>
                            </div>
                            <div className="hidden md:block">
                              {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true
                                <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                  <div className="flex items-center w-full">
                                    <img
                                      src={
                                        post.user?.profile_picture_url ||
                                        profileimg
                                      }
                                      alt="Profile"
                                      className="w-10 h-10 rounded-full object-cover"
                                    />
                                    <input
                                      type="text"
                                      placeholder="Add a comment..."
                                      value={commentInputs[post.id] || ""} // Bind input to state
                                      maxLength={1000}
                                      onChange={(e) =>
                                        handleCommentChange(
                                          post.id,
                                          e.target.value
                                        )
                                      }
                                      className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                    />
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <button>
                                      <img
                                        src={smileyIcon}
                                        alt="Smiley"
                                        className="w-8 h-5"
                                      />
                                    </button>

                                    <label className="cursor-pointer">
                                      <img
                                        src={galleryicon}
                                        alt={post.groupName}
                                        className="w-8 h-5"
                                      />
                                      <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handleFileUpload}
                                      />
                                    </label>

                                    <label className="cursor-pointer">
                                      <img
                                        src={videoicon}
                                        alt={post.groupName}
                                        className="w-8 h-5"
                                      />
                                      <input
                                        type="file"
                                        multiple
                                        accept="video/*"
                                        className="hidden"
                                        onChange={handleFileUpload} // ✅ Can reuse this function
                                      />
                                    </label>

                                    <div className="file-previews flex flex-wrap gap-4 mt-4">
                                      {filePreviews.map((preview, index) => (
                                        <div key={index} className="relative">
                                          {preview.type === "image" ? (
                                            <img
                                              src={preview.url}
                                              alt={`Preview ${index}`}
                                              className="w-20 h-20 object-cover rounded-lg"
                                            />
                                          ) : (
                                            <video
                                              src={preview.url}
                                              controls
                                              className="w-20 h-20 object-cover rounded-lg"
                                            />
                                          )}
                                          <button
                                            onClick={() =>
                                              handleRemoveFile(index)
                                            }
                                            className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                    <button
                                      onClick={() =>
                                        handleCommentSubmit(
                                          post.id,
                                          commentInputs[post.id],
                                          uploadedMedia
                                        )
                                      }
                                      disabled={sendingCommentId === post.id}
                                      className={`px-4 py-1 rounded-full ${
                                        sendingCommentId === post.id
                                          ? "bg-gray-400 cursor-not-allowed"
                                          : "bg-[#095228] text-white"
                                      }`}
                                    >
                                      {sendingCommentId === post.id
                                        ? "Sending..."
                                        : "Send"}
                                    </button>

                                   
                                    <Modal
                                      isOpen={isCommentsModalOpen}
                                      onRequestClose={closeCommentsModal}
                                      contentLabel="Comments"
                                      className="modal"
                                      overlayClassName="overlay"
                                    >
                                      <h2 className="text-xl font-bold mb-4">
                                        Comments
                                      </h2>
                                      <ul>
                                        {comments.map((comment, index) => (
                                          <li key={index} className="mb-2">
                                            <p className="font-bold">
                                              {comment.user?.username ||
                                                "Unknown User"}
                                            </p>
                                            <p className="text-sm text-gray-500">
                                              {comment.content}
                                            </p>
                                          </li>
                                        ))}
                                      </ul>
                                      <button
                                        onClick={closeCommentsModal}
                                        className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                      >
                                        Close
                                      </button>
                                    </Modal>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No post available.</p>
                      )}
                    </div> */}
                  </div>
                )}
                {/* {activeTab === "Followers" && <p>🚀 Displaying Followers Feed...</p>} */}
                {activeTab === "Followers" && (
                  <div>
                    {/*  */}
                    {loading && <p>Loading posts...</p>}
                    <div className="w-full">
                      {posts?.length > 0 ? (
                        posts.map((post, index) =>
                          post.is_donation ? (
                            <div>
                              <div
                                key={post.id}
                                className="p-4 border-b bg-[#EBF8ED] home-donation-feeds"
                              >
                                <div className="flex items-center">
                                  <img
                                    src={post.banner_image?.url || profileimg}
                                    alt={post.user?.username || "banner"}
                                    className="w-full h-full donation-banner mr-4"
                                  />
                                </div>

                                <button
                                  onClick={() => openPopupdonate(post)}
                                  className="w-full"
                                >
                                  <div className="mt-4 flex gap-3">
                                    {post?.media_url?.length > 0 &&
                                      post.media_url.map(
                                        (media, mediaIndex) => (
                                          <div key={mediaIndex}>
                                            {media.media_type === "video" ? (
                                              <video
                                                src={media.url}
                                                controls
                                                width="58px"
                                                height="57px"
                                                className="rounded-lg"
                                              />
                                            ) : (
                                              <img
                                                src={media.url}
                                                alt={`media-${mediaIndex}`}
                                                width="130px"
                                                height="120px"
                                                className="rounded-lg"
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                  </div>

                                  {post.followersList?.map((group, index) => (
                                    <div
                                      key={index}
                                      className="followers-title-content flex items-center justify-between space-x-4 my-4 mx-5"
                                    >
                                      <div className="flex items-center">
                                        <img
                                          src={group.profile_image || userimg}
                                          alt={group.username}
                                          className="w-12 h-12 rounded-full"
                                        />
                                        <div className="ml-1">
                                          <p className="follower-title-name titlesemibold font-semibold">
                                            {group.username}
                                          </p>
                                          <p className="members text-left text-sm text-gray-500">
                                            {group.followers_date}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="view-sharepost-drpdown">
                                        <button
                                          onClick={toggleDropdown}
                                          className="share-public flex items-center px-2 py-2"
                                        >
                                          <img
                                            src={morecircle}
                                            alt="Globe"
                                            className=""
                                          />
                                        </button>

                                        {isOpen && (
                                          <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                                            <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                              Edit
                                            </button>
                                            <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">
                                              Delete
                                            </button>
                                            {/* <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button> */}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}

                                  <div className="flex items-center justify-between my-4 mx-5">
                                    <div className="flex items-center w-full">
                                      <div className="flex items-center justify-between w-full">
                                        <div className="flex items-center justify-start ">
                                          <img
                                            src={profilePictureUrl || profileimg}
                                            alt="Profile"
                                            className="w-10 h-10 rounded-full object-cover"
                                          />
                                          <div className="ml-2 text-left">
                                            <h2
                                              className="font-[600] cursor-pointer text-[14px]"
                                              onClick={(e) => {
                                                e.stopPropagation(); // Prevents the parent button's onClick
                                                handleUsernameClick(
                                                  post.user?.id,
                                                );
                                              }}
                                            >
                                              {post.user?.username ||
                                                "Unknown User"}
                                            </h2>

                                            <p className="text-[12px] text-[#747474CC]">
                                              {post.created_at
                                                ? formatDateTime(
                                                    post.created_at,
                                                    { hour12: true },
                                                  )
                                                : "No Date"}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="flex items-center justify-end relative">
                                          {/* Ellipsis Button */}
                                          {/* <button
                                          onClick={() =>
                                            setEllipsisMenuOpen(
                                              !ellipsisMenuOpen
                                            )
                                          }
                                          className="p-2 rounded-full hover:bg-gray-100"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 30 30"
                                            fill="none"
                                          >
                                            <path
                                              d="M15 27.5C21.875 27.5 27.5 21.875 27.5 15C27.5 8.125 21.875 2.5 15 2.5C8.125 2.5 2.5 8.125 2.5 15C2.5 21.875 8.125 27.5 15 27.5Z"
                                              stroke="#292D32"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M19.9956 15H20.0068"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M14.9941 15H15.0053"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M9.99313 15H10.0044"
                                              stroke="#292D32"
                                              stroke-width="3"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </button> */}

                                          {/* Dropdown Menu */}
                                          {/* {ellipsisMenuOpen && (
                                          <div className="absolute top-8 left-0 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                                            <ul className="py-1 text-sm text-gray-700">
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Edit
                                                </button>
                                              </li>
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Delete
                                                </button>
                                              </li>
                                              <li>
                                                <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                                                  Share
                                                </button>
                                              </li>
                                            </ul>
                                          </div>
                                        )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <h2 className="font-[600] cursor-pointer text-[22px] mx-5 text-left">
                                    {" "}
                                    {post.title ||
                                      post.user?.username ||
                                      "Unknown User"}
                                  </h2>

                                  <div className="text-sm text-[#0F5F1A] flex items-center justify-start mx-5">
                                    <p className="text-[10px] text-[#747474CC] ">
                                      <p className="font-bold cursor-pointer text-black-500">
                                        {post.created_at
                                          ? formatDateTime(post.created_at, {
                                              hour12: true,
                                            })
                                          : "No Date"}
                                      </p>
                                    </p>
                                    &nbsp;|
                                    <div className="flex items-center justify-start">
                                      {post.isPublic === false ? (
                                        <FaLock className="w-[10px] h-[10px] mx-1" />
                                      ) : (
                                        <img
                                          src={greenglobal}
                                          alt=""
                                          className="w-[10px] h-[10px] mx-1"
                                        />
                                      )}
                                      {post.isPublic === false ? "Private" : "Public"}
                                    </div>
                                  </div>
                                  <p
                                    className="mt-3 mx-5 text-[12px] cursor-pointer font-[400] text-left"
                                    onClick={() => {
                                      setSelectedDonation(post);
                                      setShowDonationPopup(true);
                                    }}
                                  >
                                    {linkify(post.content)}
                                  </p>
                                </button>

                                {/* Date and Progress */}
                                <div className="flex items-center justify-between gap-3 p-4 rounded-md w-full my-5 mx-2">
                                  <ProgressBar
                                    donatorsCount={
                                      Number(post.donatorCount) || 0
                                    } // ✅ Use donatorCount from post
                                    // daysLeft={calculateDaysLeft(
                                    //   post.start_date,
                                    //   post.end_date
                                    // )}
                                    daysLeft={calculateDaysLeft(post.end_date)}
                                    current={
                                      Number(post.totalDonatedAmount) || 0
                                    }
                                    max={Number(post.donation_target) || 100}
                                    percentage={
                                      (Number(post.totalDonatedAmount || 0) /
                                        Number(post.donation_target || 1)) *
                                      100
                                    }
                                  />

                                  <div className="w-full max-w-[300px] flex items-center flex-end gap-2">
                                    <img src={calender} alt="Calendar" />
                                    <span className="text-black text-[12px] font-[500] font-poppins">
                                      {new Date(
                                        post.start_date,
                                      ).toLocaleDateString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}{" "}
                                      -{" "}
                                      {new Date(
                                        post.end_date,
                                      ).toLocaleDateString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </span>
                                  </div>
                                </div>

                                {/* Reactions */}
                                <div className="react-social-cta flex justify-between items-center mt-8 mx-5">
                                  <div className="flex space-x-4">
                                    <button
                                      onClick={(e) => {
                                        // Tapping the pill itself (not only the small heart) likes the post; the heart and the count keep their own handlers.
                                        if (e.target === e.currentTarget && !likingPosts.has(post.id)) handleLikeClick(post.id);
                                      }}
                                      className="like flex items-center space-x-1 text-white px-3 py-2"
                                      style={{
                                        background: post.isLiked
                                          ? "#F9E9EA"
                                          : "#BE1F2E",
                                      }}
                                    >
                                      <img
                                        src={
                                          post.isLiked
                                            ? RedlikeIcon
                                            : Whiteheart
                                        }
                                        alt="Like"
                                        // className="flex items-center space-x-1 px-2 py-1 "
                                        disabled={likingPosts.has(post.id)}
                                        onClick={() => handleLikeClick(post.id)}
                                        className={`flex items-center space-x-1 px-2 py-1 ${
                                          likingPosts.has(post.id)
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                      />
                                      <span
                                        className="cursor-pointer"
                                        style={{
                                          color: post.isLiked
                                            ? "#161F28"
                                            : "#FFFFFF",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                          fetchLikedUsers(post.id);
                                        }}
                                      >
                                        {post.likeCount}
                                      </span>
                                    </button>

                                    <button
                                      onClick={() =>
                                        toggleCommentSection(post.id)
                                      }
                                      className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-2"
                                    >
                                      <img
                                        src={commentIcon}
                                        alt="Comment"
                                        className="mx-1"
                                      />
                                      <span class="cursor-pointer">
                                        {post.commentCount}
                                      </span>
                                    </button>

                                    {/* <button className="eye flex items-center space-x-1 text-black">
                                    <img
                                      src={viewIcon}
                                      alt="Views"
                                      className="mr-1"
                                    />
                                    {post.viewsCount} Views
                                  </button> */}
                                  </div>
                                  <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                    <img src={like} alt="Share" />
                                    &nbsp;{post.contribution || 0}&nbsp;
                                    <span className="hidden md:block">
                                      Contributions
                                    </span>
                                  </button>
                                  <button
                                    className="flex items-center space-x-1 text-[#fff] share-post-cta"
                                    onClick={() =>
                                      handleShareClick(post.share_text)
                                    }
                                  >
                                    <img src={shareIcon} alt="Share" />
                                    &nbsp;
                                    <span className="hidden md:block">
                                      Share
                                    </span>
                                  </button>
                                  {/* Share Modal */}
                                  <ShareModal
                                    isOpen={isShareModalOpen}
                                    onClose={() => setIsShareModalOpen(false)}
                                    shareUrl={currentPostUrl}
                                  />
                                </div>
                              </div>
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true
                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img
                                        src={
                                          post.user?.profile_picture_url ||
                                          profileimg
                                        }
                                        alt="Profile"
                                        className="w-10 h-10 rounded-full object-cover"
                                      />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        maxLength={1000}
                                        onChange={(e) =>
                                          handleCommentChange(
                                            post.id,
                                            e.target.value,
                                          )
                                        }
                                        className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center gap-1">
                                      <button>
                                        <img
                                          src={smileyIcon}
                                          alt="Smiley"
                                          className="w-8 h-5"
                                        />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}
                                        />
                                      </label>

                                      {/* ✅ Video Upload */}
                                      <label className="cursor-pointer">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="video/*"
                                          className="hidden"
                                          onChange={handleFileUpload} // ✅ Can reuse this function
                                        />
                                      </label>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() =>
                                          handleCommentSubmit(
                                            post.id,
                                            commentInputs[post.id],
                                            uploadedMedia,
                                          )
                                        }
                                        disabled={sendingCommentId === post.id}
                                        className={`px-4 py-1 rounded-full ${
                                          sendingCommentId === post.id
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-[#095228] text-white"
                                        }`}
                                      >
                                        {sendingCommentId === post.id
                                          ? "Sending..."
                                          : "Send"}
                                      </button>

                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">
                                          Comments
                                        </h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">
                                                {comment.user?.username ||
                                                  "Unknown User"}
                                              </p>
                                              <p className="text-sm text-gray-500">
                                                {comment.content}
                                              </p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div
                                key={index}
                                className="share-content relative"
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    <div className="profile-dashboard rounded-full overflow-hidden">
                                      <img
                                        src={
                                          post.user?.profile_picture_url ||
                                          profileimg
                                        }
                                        alt={post.user?.username || "User"}
                                        className="rounded-full object-cover"
                                      />
                                    </div>
                                    <div>
                                      <p
                                        className="font-semibold cursor-pointer text-black-500"
                                        onClick={() =>
                                          handleUsernameClick(post.user?.id)
                                        } // Call handleUsernameClick on click
                                      >
                                        {post.user?.username || "Unknown User"}
                                      </p>
                                      <div className="flex items-center text-sm text-[#747474CC]">
                                        <p className="cursor-pointer">
                                          {post.created_at
                                            ? formatDateTime(post.created_at, {
                                                hour12: true,
                                              })
                                            : "No Date"}
                                        </p>
                                        &nbsp;|
                                        <div className="flex items-center justify-start text-[#0F5F1A]">
                                          {post.isPublic === false ? (
                                            <FaLock className="w-[10px] h-[10px] mx-1" />
                                          ) : (
                                            <img
                                              src={greenglobal}
                                              alt=""
                                              className="w-[10px] h-[10px] mx-1"
                                            />
                                          )}
                                          {post.isPublic === false ? "Private" : "Public"}
                                        </div>
                                      </div>
                                      {/* <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p> */}
                                    </div>
                                    {/* Display Location */}
                                    {post.location && (
                                      <div className="mt-2 text-sm text-gray-500">
                                        <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                        {post.location}
                                      </div>
                                    )}
                                  </div>

                                  {/* :white_check_mark: Conditionally render Follow button */}
                                  {!post.isOwn && (
                                    <button
                                      onClick={() =>
                                        handleFollowClick(
                                          post.user_id,
                                          post.user?.privacy_status,
                                        )
                                      }
                                      className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${
                                        post.myStatus === "accepted"
                                          ? "bg-gray-400 text-white" // :white_check_mark: Following
                                          : post.myStatus === "pending"
                                            ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                            : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                      disabled={
                                        post.myStatus === "pending" ||
                                        post.myStatus === "accepted"
                                      } // :white_check_mark: Disable after clicking
                                    >
                                      {post.myStatus === "accepted"
                                        ? "Following"
                                        : post.myStatus === "pending"
                                          ? "Requested"
                                          : "Follow"}
                                    </button>
                                  )}
                                </div>
                                <button
                                  placeholder="Share something..."
                                  className=""
                                  onClick={() => openPopup(post)}
                                >
                                  {/* <p className="mt-2 text-left">
                                    {linkify(post.content)}
                                  </p>{" "} */}
                                  <p className="mt-4 mb-4 text-black text-justify break-all">
                                    {expandedPosts[index]
                                      ? linkify(post.content)
                                      : linkify(
                                          `${post.content?.slice(0, 276)}`,
                                        )}
                                    {post.content?.length > 276 && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); // 🚫 prevent popup
                                          toggleReadMore(index);
                                        }}
                                        className="text-[#095228] italic hover:underline font-semibold ml-2"
                                      >
                                        {expandedPosts[index]
                                          ? "Read Less"
                                          : "Read More"}
                                      </button>
                                    )}
                                  </p>
                                  {/* :white_check_mark: Render Multiple Media Files */}
                                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {post?.media_url?.length > 0 &&
                                      post?.media_url?.map(
                                        (media, mediaIndex) => (
                                          <div key={mediaIndex}>
                                            {media?.media_type === "video" ? (
                                              <PostVideo
                                                src={media?.url}
                                                soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} licenceNeeded={post?.licence_needed}
                                                className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                              />
                                            ) : (
                                              <img
                                                src={media?.url}
                                                alt={`media-${mediaIndex}`}
                                                width="100%"
                                                className="rounded-lg shadow-md object-cover w-full h-[250px] w-auto h-full object-cover max-h-[300px]"
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                  </div>
                                </button>
                                {post?.sound_id && !post?.media_url?.some((m) => m?.media_type === "video") && <PostSound soundId={post.sound_id} silenced={post?.rights_enforcement === "mute"} />}
                                {/* Social Buttons */}
                                <div className="react-social-cta flex justify-between items-center mt-8">
                                  <div className="flex space-x-4">
                                    <button
                                      onClick={(e) => {
                                        // Tapping the pill itself (not only the small heart) likes the post; the heart and the count keep their own handlers.
                                        if (e.target === e.currentTarget && !likingPosts.has(post.id)) handleLikeClick(post.id);
                                      }}
                                      className="like flex items-center space-x-1 border-[#BE1F2E] border-2 text-white px-3 py-1"
                                      style={{
                                        background: post.isLiked
                                          ? "#F9E9EA"
                                          : "#BE1F2E",
                                      }}
                                    >
                                      {/* Heart Icon: Calls handleLikeClick */}
                                      <img
                                        src={
                                          post.isLiked
                                            ? RedlikeIcon
                                            : Whiteheart
                                        } // Use a filled heart icon if liked
                                        alt="Like"
                                        disabled={likingPosts.has(post.id)}
                                        onClick={() => handleLikeClick(post.id)}
                                        className={`flex items-center space-x-1 px-2 py-1 w-[32px] ${
                                          likingPosts.has(post.id)
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                      />

                                      {/* Like Count: Calls fetchLikedUsers */}
                                      <span
                                        className="cursor-pointer"
                                        style={{
                                          color: post.isLiked
                                            ? "#161F28"
                                            : "#FFFFFF",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation(); // Prevent triggering parent click events
                                          const rect = e.currentTarget.getBoundingClientRect();
                                          setLikedUsersPopupPosition(getClampedPopupPosition(rect));
                                          fetchLikedUsers(post.id); // Call fetchLikedUsers
                                        }}
                                      >
                                        {post.likeCount}
                                      </span>
                                    </button>

                                    <button
                                      onClick={() =>
                                        toggleCommentSection(post.id)
                                      } // Toggle comment section
                                      className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1"
                                    >
                                      <img
                                        src={commentIcon}
                                        alt="Comment"
                                        className="flex items-center space-x-1 px-2 py-1 "
                                      />
                                      <button
                                        placeholder="Share something..."
                                        className="cursor-pointer"
                                        onClick={() => openPopup(post)}
                                      >
                                        {post.commentCount}
                                      </button>
                                    </button>

                                    <button
                                      onClick={() =>
                                        toggleCommentSection(post.id)
                                      }
                                      className="eye flex items-center space-x-1 text-black"
                                    >
                                      {/* <img
                                      src={viewIcon}
                                      alt="Views"
                                      className="mr-1"
                                    /> */}
                                      {/* <button
                                      placeholder="Share something..."
                                      className=""
                                      onClick={openPopup}
                                    >
                                      {" "}
                                      {post.viewsCount} Views
                                    </button> */}
                                    </button>
                                  </div>
                                  <button
                                    className="flex items-center space-x-1 text-[#fff] share-post-cta"
                                    onClick={() =>
                                      handleShareClick(post.share_text)
                                    }
                                  >
                                    <img src={shareIcon} alt="Share" />
                                    &nbsp;
                                    <span className="hidden md:block">
                                      Share
                                    </span>
                                  </button>
                                  {/* Share Modal */}
                                  <ShareModal
                                    isOpen={isShareModalOpen}
                                    onClose={() => setIsShareModalOpen(false)}
                                    shareUrl={currentPostUrl}
                                  />
                                </div>
                                {/* Popup for Liked Users */}
                                {isModalOpen && selectedPostId === post.id && (
                                  <div className="fixed inset-0 bg-[#00000005] w-full  z-40">
                                    <div
                                      onScroll={handleScrollLikedPost} // Attach the scroll handler
                                      style={likedUsersPopupPosition ? { position: "fixed", top: likedUsersPopupPosition.top, left: likedUsersPopupPosition.left, maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" } : { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", maxHeight: POPUP_MAX_HEIGHT, overflowY: "auto" }}
                                      className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative"
                                    >
                                      <h2 className="text-xl font-bold mb-4">
                                        Users who liked this post
                                      </h2>
                                      <ul>
                                        {likedUsers?.length > 0 ? (
                                          likedUsers.map((user, index) => (
                                            <li
                                              key={index}
                                              className="mb-2 flex items-center justify-between"
                                            >
                                              <div className="flex items-center min-w-0 flex-1 mr-2">
                                                <img
                                                  src={
                                                    user.profile_picture_url ||
                                                    profileimg
                                                  }
                                                  alt={user.username}
                                                  className="w-8 h-8 rounded-full inline-block mr-2"
                                                />
                                                <div className="min-w-0">
                                                  <p className="font-bold truncate">
                                                    {user.username}
                                                  </p>
                                                  <p className="text-sm text-gray-500 break-all">
                                                    {user.email}
                                                  </p>
                                                </div>
                                              </div>
                                              {user.id !== currentUserId && ( // prevent showing follow for self
                                                <button
                                                  onClick={() =>
                                                    handleFollowClick(
                                                      user.id,
                                                      user.privacy_status,
                                                    )
                                                  }
                                                  className={`px-4 py-1 rounded-full flex-shrink-0 whitespace-nowrap ${
                                                    user.myStatus === "accepted"
                                                      ? "bg-gray-400 text-white" // Following
                                                      : user.myStatus ===
                                                          "pending"
                                                        ? "bg-yellow-500 text-black" // Requested
                                                        : "bg-[#095228] text-white" // Follow
                                                  }`}
                                                  disabled={
                                                    user.myStatus === "pending" ||
                                                    user.myStatus === "accepted"
                                                  } // Disable if already following or requested
                                                >
                                                  {user.myStatus === "accepted"
                                                    ? "Following"
                                                    : user.myStatus === "pending"
                                                      ? "Requested"
                                                      : "Follow"}
                                                </button>
                                              )}
                                            </li>
                                          ))
                                        ) : (
                                          <p>No users found.</p>
                                        )}
                                      </ul>
                                      {hasMoreUsers && (
                                        <p className="text-center text-gray-500 mt-4">
                                          Loading more...
                                        </p>
                                      )}

                                      <button
                                        onClick={closeModal}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              {/* Comment Section */}
                              <div className="hidden md:block mb-5">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true
                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img
                                        src={profilePictureUrl || profileimg}
                                        alt="Profile"
                                        className="w-10 h-10 rounded-full object-cover"
                                      />
                                      <input
                                        type="text"
                                        placeholder="Add Comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        maxLength={1000}
                                        onChange={(e) =>
                                          handleCommentChange(
                                            post.id,
                                            e.target.value,
                                          )
                                        }
                                        className="flex-1 min-w-0 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="relative flex items-center gap-1">
                                      <button
                                        onClick={() =>
                                          setShowEmojiPicker((prev) => !prev)
                                        }
                                      >
                                        <img
                                          src={smileyIcon}
                                          alt="Smiley"
                                          className="w-8 h-5"
                                        />
                                      </button>
                                      {showEmojiPicker && (
                                        <div
                                          ref={emojiPickerRef}
                                          className="absolute z-50 bottom-full right-0 mb-2"
                                        >
                                          <Picker
                                            // onSelect={(emoji) =>
                                            //   handleCommentChange(
                                            //     post.id,
                                            //     (commentInputs[post.id] || '') + emoji.native
                                            //   )
                                            // }
                                            data={data}
                                            onEmojiSelect={(emoji) => {
                                              handleCommentChange(
                                                post.id,
                                                (commentInputs[post.id] || "") +
                                                  emoji.native,
                                              );
                                              setShowEmojiPicker(false);
                                            }}
                                            title="Pick an emoji"
                                          />
                                        </div>
                                      )}

                                      <label className="cursor-pointer ">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*,video/*"
                                          className="hidden"
                                          onChange={handleFileUpload}
                                        />
                                      </label>

                                      <button className="pr-2">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-8 h-5"
                                        />
                                      </button>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {uploadedMedia.map((media, index) => (
                                          <div key={index} className="relative">
                                            {media.type === "image" ? (
                                              <img
                                                src={media.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={media.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      {/* <button
                                      onClick={() =>
                                        handleCommentSubmit(
                                          post.id,
                                          commentInputs[post.id],
                                          uploadedMedia
                                        )
                                      }
                                      className="bg-[#095228] text-white px-4 py-1 rounded-full"
                                    >
                                      Send
                                      </button> */}

                                      <button
                                        onClick={() =>
                                          handleCommentSubmit(
                                            post.id,
                                            commentInputs[post.id],
                                            uploadedMedia,
                                          )
                                        }
                                        disabled={sendingCommentId === post.id}
                                        className={`px-4 py-1 rounded-full ${
                                          sendingCommentId === post.id
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-[#095228] text-white"
                                        }`}
                                      >
                                        {sendingCommentId === post.id
                                          ? "Sending..."
                                          : "Send"}
                                      </button>

                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">
                                          Comments
                                        </h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">
                                                {comment.user?.username ||
                                                  "Unknown User"}
                                              </p>
                                              <p className="text-sm text-gray-500">
                                                {comment.content}
                                              </p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <p>No posts available.</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* <Viewpost /> */}
            <RightResponsivesidebar showSponsoredAds />
          </div>
          {/* Right Sidebar */}
          <Rightsidebar showSponsoredAds />
        </main>
      </main>

      <div>
        {/* Create Post */}

        {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
        {isPopupOpen && (
          <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
            <div
              className="border-popup bg-white rounded-lg  relative"
              ref={modalRef}
            >
              <div className="flex justify-between">
                <div className="logo-popup flex items-center justify-center space-x-2 ">
                  <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
                </div>
                {/* Close Button */}
                <button
                  className="close-pop-x relative  text-gray-500"
                  onClick={() => {
                    setIsPopupOpen(false);
                    navigate("/home");
                  }}
                >
                  {" "}
                  <img
                    src={closecircle}
                    alt="Nyawoo Logo"
                    className="w-10 h-10"
                  />
                </button>
              </div>
              {/* Modal Content */}
              {/* Swiper Banner with Thumbnails */}
              <div className="swiper-viewpost-slider border-red-500 max-h-[800px]">
                <div className="relative max-h-[500px]">
                  <Swiper
                    modules={[Navigation, Pagination, Thumbs]}
                    navigation
                    pagination={false}
                    thumbs={{
                      swiper:
                        thumbsSwiper && !thumbsSwiper.destroyed
                          ? thumbsSwiper
                          : null,
                    }} // ✅ Link with thumbnails
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex)
                    } // ✅ Track active slide
                    className="rounded-lg mt-4 view-post-swiper"
                  >
                    {selectedPost?.media_url?.map((media, index) => (
                      <SwiperSlide key={index}>
                        {media.media_type === "video" ? (
                          <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                            {selectedPost?.sound_id ? (
<PostVideo src={media.url} soundId={selectedPost?.sound_id} silenced={selectedPost?.rights_enforcement === "mute"} licenceNeeded={selectedPost?.licence_needed} className="rounded-lg w-full max-h-[400px]" />
) : (
<ReactPlayer
                              url={media.url}
                              playing={playingIndex === index} // ✅ Play only when clicked
                              controls
                              width="auto"
                              height="100%"
                              className="rounded-lg h-full video-player-swiper"
                              // light={groupimg} // ✅ Thumbnail before playing

                              playIcon={
                                <img src={play} alt="Play" className="player" />
                              }
                            />
)}
                          </div>
                        ) : (
                          <img
                            src={media.url}
                            alt={`Slide ${index}`}
                            className="w-full max-h-[400px] object-contain rounded-lg transition-transform duration-300"
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Zoom Buttons (Apply to Active Image Only) */}
                  {/* <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                    <div className="flex">
                      <button onClick={zoomIn} className=" p-2 rounded-lg ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                      <button onClick={zoomOut} className=" p-2 rounded-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z"
                            fill="#292D32"
                          />
                          <path
                            d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                    </div>
                    <span className="h-5 border-r border-[#7A7A7A]"></span>
                    <button className=" p-2 rounded-lg ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                      >
                        <path
                          d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z"
                          fill="#292D32"
                        />
                        <path
                          d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z"
                          fill="#292D32"
                        />
                        <path
                          d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z"
                          fill="#292D32"
                        />
                      </svg>
                    </button>
                  </div> */}
                </div>
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {!isVideo && (
                  <Swiper
                    onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                    spaceBetween={5}
                    slidesPerView={6}
                    freeMode
                    watchSlidesProgress
                    className="mt-2"
                  >
                    {selectedPost?.media_url?.map((media, index) =>
                      media.media_type === "image" ? (
                        <SwiperSlide
                          key={index}
                          onClick={() =>
                            thumbsSwiper && thumbsSwiper.slideTo(index)
                          }
                        >
                          <img
                            src={media.url}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-16 md:h-[140px] object-cover rounded-lg cursor-pointer m-auto border border-[#B4B7C9]"
                          />
                        </SwiperSlide>
                      ) : null,
                    )}
                  </Swiper>
                )}
              </div>

              {/* Content Below */}
              <div className="w-full">
                {selectedPostId && selectedPost ? (
                  <div className="share-content relative">
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        {/* <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1 gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="17"
                            viewBox="0 0 19 17"
                            fill="none"
                            className="mr-1"
                          >
                            <path
                              d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z"
                              stroke="#BE1F2E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>{" "}
                          {selectedPost.likeCount}k
                        </button> */}
                      </div>
                      {selectedPostId && selectedPost && (
                        <button
                          className="flex items-center space-x-1 text-[#fff] share-post-cta"
                          onClick={() =>
                            handleShareClick(selectedPost.share_text)
                          }
                        >
                          <img src={shareIcon} alt="Share" />
                          &nbsp;Share
                        </button>
                      )}
                      {/* Share Modal */}
                      <ShareModal
                        isOpen={isShareModalOpen}
                        onClose={() => setIsShareModalOpen(false)}
                        shareUrl={currentPostUrl}
                      />
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img
                            src={
                              selectedPost.user?.profile_picture_url ||
                              profileimg
                            }
                            alt={selectedPost.user?.username || "User"}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">
                            {selectedPost.user?.username || "Unknown User"}
                          </p>
                          <p className="flex text-sm text-[#747474]">
                            {formatDateTime(selectedPost.created_at)} |
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex">
                        <div className="view-sharepost-drpdown">
                          {/* <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button> */}

                          {/* {isOpen && (
                            <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Edit</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Delete</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                    {selectedPost?.title && (
                      <h2 className="text-2xl font-semibold text-[#095228] ml-[80px] mt-4">
                        {selectedPost.title}
                      </h2>
                    )}
                    <p className="my-4 ml-[80px]">
                      {linkify(selectedPost.content)}
                    </p>{" "}
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
              {/* CHAT CONTENT AREA */}
              <div className="dashboard w-full  flex mx-auto">
                <main className="flex w-full">
                  <div className="flex flex-col  w-full">
                    {/* CHAT FOOTER (INPUT AREA) */}
                    <CommentSection
                      comments={comments}
                      setComments={setComments}
                      postId={selectedPostId}
                      handleCommentSubmit={handleCommentSubmit}
                      fetchReplies={fetchReplies}
                      handleCommentLikeClick={handleCommentLikeClick}
                      fetchComments={fetchComments}
                      handleFileUpload={handleFileUpload}
                      uploadFiles={uploadFiles} // Pass uploadFiles as a prop
                      showEmojiPicker={showEmojiPicker}
                      emojiPickerRef={emojiPickerRef}
                      handleCommentChange={handleCommentChange}
                      commentInputs={commentInputs}
                      setShowEmojiPicker={setShowEmojiPicker}
                    />{" "}
                  </div>
                </main>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {/* Donation Post */}

        {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
        {isdonatePopupOpen && (
          <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
            <div className="border-popup bg-white rounded-lg  relative">
              <div className="flex justify-between">
                <div className="logo-popup flex items-center justify-center space-x-2 ">
                  <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
                </div>
                {/* Close Button */}
                <button
                  className="close-pop-x relative  text-gray-500"
                  onClick={() => {
                    setIsdonatePopupOpen(false);
                    navigate("/home");
                  }}
                >
                  {" "}
                  <img
                    src={closecircle}
                    alt="Nyawoo Logo"
                    className="w-10 h-10"
                  />
                </button>
              </div>
              {/* Modal Content */}
              {/* Swiper Banner with Thumbnails */}
              <div className="swiper-viewpost-slider">
                <div className="relative">
                  <Swiper
                    modules={[Navigation, Pagination, Thumbs]}
                    navigation
                    pagination={{ clickable: true }}
                    thumbs={{
                      swiper:
                        thumbsSwiper && !thumbsSwiper.destroyed
                          ? thumbsSwiper
                          : null,
                    }} // ✅ Link with thumbnails
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex)
                    } // ✅ Track active slide
                    className="rounded-lg mt-4 view-post-swiper"
                  >
                    {popupMedia.map((media, index) => (
                      <SwiperSlide key={index}>
                        {media.media_type === "video" ? (
                          <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                            {popupPost?.sound_id ? (
<PostVideo src={media.url} soundId={popupPost?.sound_id} silenced={popupPost?.rights_enforcement === "mute"} licenceNeeded={popupPost?.licence_needed} className="rounded-lg w-full max-h-[400px]" />
) : (
<ReactPlayer
                              url={media.url}
                              playing={playingIndex === index} // ✅ Play only when clicked
                              controls
                              width="auto"
                              height="100%"
                              className="rounded-lg h-full video-player-swiper"
                              light={groupimg} // ✅ Thumbnail before playing
                              playIcon={
                                <img src={play} alt="Play" className="player" />
                              }
                            />
)}
                          </div>
                        ) : (
                          <img
                            src={media.url}
                            alt={`Slide ${index}`}
                            className="w-full max-h-[800px] object-contain rounded-lg transition-transform duration-300"
                            style={{ transform: `scale(${zoomLevels[index] || 1})` }}
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Zoom Buttons (Apply to Active Image Only) */}
                  <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                    <div className="flex">
                      <button onClick={zoomIn} className=" p-2 rounded-lg ">
                        {/* <img src={zoomInicon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                      <button onClick={zoomOut} className=" p-2 rounded-lg">
                        {/* <img src={zoomOuticon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z"
                            fill="#292D32"
                          />
                          <path
                            d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                    </div>
                    <span className="h-5 border-r border-[#7A7A7A]"></span>
                    <button
                      className=" p-2 rounded-lg "
                      onClick={() => {
                        const url = popupMedia[activeIndex]?.url;
                        if (url) window.open(url, "_blank", "noopener,noreferrer");
                      }}
                    >
                      {/* <img src={exporticon} className="w-[16.8px] h-[16.8px]" /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                      >
                        <path
                          d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z"
                          fill="#292D32"
                        />
                        <path
                          d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z"
                          fill="#292D32"
                        />
                        <path
                          d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z"
                          fill="#292D32"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {!isVideo && (
                  <Swiper
                    onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode
                    watchSlidesProgress
                    className="mt-2"
                  >
                    {popupMedia.map((media, index) =>
                      media.media_type === "image" ? (
                        <SwiperSlide
                          key={index}
                          onClick={() =>
                            thumbsSwiper && thumbsSwiper.slideTo(index)
                          }
                        >
                          <img
                            src={media.url}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-20 md:h-[200px] object-contain rounded-lg cursor-pointer  border border-[#B4B7C9]"
                          />
                        </SwiperSlide>
                      ) : null,
                    )}
                  </Swiper>
                )}
              </div>

              {/* Content Below */}
              <div className="w-full">
                {selectedPostId && selectedPost ? (
                  <div className="share-content relative">
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1 gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="17"
                            viewBox="0 0 19 17"
                            fill="none"
                            className="mr-1"
                          >
                            <path
                              d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z"
                              stroke="#BE1F2E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>{" "}
                          {selectedPost.likeCount}k
                        </button>
                      </div>
                      <button className="flex items-center space-x-1 text-[#fff] share-post-cta ml-3">
                        <img src={shareIcon} alt="Share" className="" />
                        &nbsp;Share
                      </button>
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img
                            src={
                              selectedPost.user?.profile_picture_url ||
                              profileimg
                            }
                            alt={selectedPost.user?.username || "User"}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">
                            {selectedPost.user?.username || "Unknown User"}
                          </p>
                          <p className="flex text-sm text-[#747474]">
                            {formatDateTime(selectedPost.created_at)}{" "}
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex">
                        <div className="view-sharepost-drpdown">
                          {/* <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button> */}

                          {/* {isOpen && (
                            <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Edit</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Delete</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>

                    <p className="my-4 ml-[80px]">
                      {/* {selectedPost.content}jhsbdcjhsbcjhdwbcjhw{" "} */}
                    </p>
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
              {showDonationPopup && selectedDonation && (
                <div className="space-y-2 donation-popup">
                  <h1 className="">
                    {selectedDonation.title || "Untitled Campaign"}
                  </h1>

                  <div className="flex items-center space-x-4 text-sm sub-title">
                    <span>{formatDateTime(selectedDonation.created_at)}</span>
                    <div className="flex items-center space-x-1 text-green-700 font-medium">
                      {selectedDonation.isPublic === false ? (
                        <FaLock className="w-4 h-4 mr-3" />
                      ) : (
                        <img
                          src={greenbigglobal}
                          alt="Campaigner"
                          className="w-5 h-15 rounded-full mr-3"
                        />
                      )}
                      <span className="span-public">
                        {selectedDonation.isPublic === false ? "Private" : "Public"}
                      </span>
                    </div>
                  </div>
                  <div>
                    <h2 className="h2-title">Campaign story</h2>
                    <p className="text-sm text-gray-700 mb-4">
                      {linkify(
                        selectedDonation.content || "No story provided.",
                      )}
                      {/* {linkify(post.content)} */}

                      {selectedDonation.tags?.map((tag, idx) => (
                        <span
                          key={idx}
                          className="inline-block bg-gray-200 text-xs px-2 py-0.5 rounded ml-1 text-green-800 font-semibold"
                        >
                          #{tag}
                        </span>
                      ))}
                    </p>
                  </div>
                  <h2 className="h2-title">Campaigner</h2>
                  <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center border border-gray-200 p-3 rounded-xl w-full md:w-auto">
                      <img
                        src={
                          selectedDonation.user?.profile_picture_url ||
                          profileimg
                        }
                        alt="Campaigner"
                        className="w-12 h-12 rounded-full border-2 border-yellow-400 mr-3"
                      />
                      <div>
                        <p className="font-semibold text-sm">
                          {" "}
                          {selectedDonation.user?.first_name}{" "}
                          {selectedDonation.user?.last_name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {" "}
                          {formatDateTime(selectedDonation.created_at)}
                        </p>
                      </div>
                      {/** ✅ Follow state is based only on whether I follow the campaigner */}
                      {selectedDonation.user?.id !== currentUserId && ( // prevent showing follow for self
                        <button
                          className={`ml-auto text-sm px-4 py-1.5 rounded-full ${
                            selectedDonation.myStatus === "accepted"
                              ? "bg-gray-400 text-white"
                              : selectedDonation.myStatus === "pending"
                                ? "bg-yellow-500 text-black"
                                : "text-white bg-green-700 hover:bg-green-800"
                          }`}
                          onClick={() =>
                            handleFollowClick(
                              selectedDonation.user?.id,
                              selectedDonation.user?.privacy_status,
                            )
                          }
                          disabled={
                            selectedDonation.myStatus === "accepted" ||
                            selectedDonation.myStatus === "pending"
                          }
                        >
                          {selectedDonation.myStatus === "accepted"
                            ? "Following"
                            : selectedDonation.myStatus === "pending"
                              ? "Requested"
                              : "Follow"}
                        </button>
                      )}
                    </div>

                    {isUpcomingDonation(selectedDonation) ? (
                      <button
                        disabled
                        className="flex items-center gap-2 bg-gray-400 text-white px-6 py-3 rounded-full text-base w-full md:w-auto justify-center cursor-not-allowed"
                        title="Donations open on the start date"
                      >
                        Starts on {formatDonationStart(selectedDonation)}
                      </button>
                    ) : (
                      <button
                        className="flex items-center gap-2 bg-green-800 hover:bg-green-900 text-white px-6 py-3 rounded-full text-base w-full md:w-auto justify-center"
                        onClick={() => openPopupdonatenow(selectedDonation)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                                  2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 
                                  2.09C13.09 3.81 14.76 3 16.5 
                                  3 19.58 3 22 5.42 22 8.5c0 
                                  3.78-3.4 6.86-8.55 11.54L12 21.35z"
                          />
                        </svg>
                        Donate Now
                      </button>
                    )}
                  </div>

                  <div>
                    <div>
                      <div className="flex items-center mb-6 mt-9">
                        <h3 className="text-lg font-semibold mr-2 text-[#313131]">
                          Donors
                        </h3>
                        <span className="bg-green-100 text-green-800 text-sm font-semibold px-2 py-0.5 rounded-full">
                          {new Set(donators.map((d) => d.user_id ?? d.user?.id)).size}
                        </span>
                      </div>
                      <div className="space-y-4">
                        {donatorsLoading ? (
                          <p>Loading donators...</p>
                        ) : donators?.length > 0 ? (
                          donators.map((donator, index) => (
                            <div
                              key={index}
                              className="flex justify-between items-start border-b pb-3"
                            >
                              <div className="flex items-start gap-3">
                                <img
                                  src={
                                    donator.user?.profile_picture_url ||
                                    profileimg
                                  }
                                  className="w-10 h-10 rounded-full border"
                                  alt="User"
                                />
                                <div>
                                  <p className="font-semibold text-sm">
                                    {" "}
                                    {donator.user?.first_name ||
                                      "Anonymous"}{" "}
                                    {donator.user?.last_name || ""}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    @{donator.user?.username || "donator"}
                                  </p>
                                  <p className="text-sm mt-1">
                                    Donated{" "}
                                    <span className="font-bold">
                                      ${donator.donatedAmount || 0}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <span className="text-xs text-gray-400">
                                {donator.created_at
                                  ? formatDateTime(donator.created_at)
                                  : "Just now"}
                              </span>
                            </div>
                          ))
                        ) : (
                          <p className="text-sm text-gray-500">
                            No donators yet.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* CHAT FOOTER (INPUT AREA) */}

              <div className="flex items-center p-4  chat-footer-input">
                {/* <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                  <label className="relative cursor-pointer">
                    <img
                      src={selectedGroup?.profileimg}
                      alt={selectedGroup?.groupName}
                      className="w-[80px] h-[40px] rounded-full object-cover "
                    />
                  </label>
                </div> */}
                {/* <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full">
                  <div className="flex space-x-2 ml-3 py-4 microphone-sm">
                    <button className="text-gray-400">
                      <img
                        src={Microphone}
                        alt={selectedGroup?.groupName}
                        className=""
                      />
                    </button>
                  </div>
                 
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") sendMessage();
                    }}
                    placeholder="Type your message..."
                    className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none bg-[#f8f9fa]"
                  />
                  <div className="flex space-x-2 ml-3 py-4 chat-media-icon">
                    <button className="px-3 smiley">
                      <img
                        src={Smiley}
                        alt={selectedGroup?.groupName}
                        className=""
                      />
                    </button>
                    <label className="cursor-pointer">
                      <img
                        src={galleryicon}
                        alt={selectedGroup?.groupName}
                        className=""
                      />
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        className="hidden"
                        onChange={handleImageUpload}
                      />
                    </label>
                    <button className="px-3">
                      <img
                        src={videoicon}
                        alt={selectedGroup?.groupName}
                        className=""
                      />
                    </button>
                  </div>
                  <button
                    onClick={sendMessage}
                    disabled={!connected || !message.trim()}
                    className="mx-2 bg-[#095228] text-white px-5 py-3 h-full rounded-[25px]"
                  >
                    Send
                  </button>
                </div> */}
              </div>
              {/* CHAT CONTENT AREA */}
              <div className="dashboard w-full  flex mx-auto">
                <main className="flex w-full">
                  <div className="flex flex-col  w-full">
                    {/* CHAT FOOTER (INPUT AREA) */}
                    <CommentSection
                      comments={comments}
                      setComments={setComments}
                      postId={selectedPostId}
                      handleCommentSubmit={handleCommentSubmit}
                      fetchReplies={fetchReplies}
                      handleCommentLikeClick={handleCommentLikeClick}
                      fetchComments={fetchComments}
                      handleFileUpload={handleFileUpload}
                      uploadFiles={uploadFiles} // Pass uploadFiles as a prop
                      showEmojiPicker={showEmojiPicker}
                      emojiPickerRef={emojiPickerRef}
                      handleCommentChange={handleCommentChange}
                      commentInputs={commentInputs}
                      setShowEmojiPicker={setShowEmojiPicker}
                    />{" "}
                  </div>
                </main>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {/* Donate Now Post */}

        {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
        {isdonatenowPopupOpen && (
          <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
            <div className="border-popup bg-white rounded-lg  relative">
              <div className="flex justify-between">
                <div className="logo-popup flex items-center justify-center space-x-2 ">
                  <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
                </div>
                {/* Close Button */}
                <button
                  className="close-pop-x relative  text-gray-500"
                  onClick={() => setIsdonatenowPopupOpen(false)}
                >
                  {" "}
                  <img
                    src={closecircle}
                    alt="Nyawoo Logo"
                    className="w-10 h-10"
                  />
                </button>
              </div>
              {/* Modal Content */}
              {/* Swiper Banner with Thumbnails */}
              <div className="swiper-viewpost-slider">
                <div className="relative">
                  <Swiper
                    modules={[Navigation, Pagination, Thumbs]}
                    navigation
                    pagination={{ clickable: true }}
                    thumbs={{
                      swiper:
                        thumbsSwiper && !thumbsSwiper.destroyed
                          ? thumbsSwiper
                          : null,
                    }} // ✅ Link with thumbnails
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex)
                    } // ✅ Track active slide
                    className="rounded-lg mt-4 view-post-swiper"
                  >
                    {popupMedia.map((media, index) => (
                      <SwiperSlide key={index}>
                        {media.media_type === "video" ? (
                          <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                            {popupPost?.sound_id ? (
<PostVideo src={media.url} soundId={popupPost?.sound_id} silenced={popupPost?.rights_enforcement === "mute"} licenceNeeded={popupPost?.licence_needed} className="rounded-lg w-full max-h-[400px]" />
) : (
<ReactPlayer
                              url={media.url}
                              playing={playingIndex === index} // ✅ Play only when clicked
                              controls
                              width="auto"
                              height="100%"
                              className="rounded-lg h-full video-player-swiper"
                              light={groupimg} // ✅ Thumbnail before playing
                              playIcon={
                                <img src={play} alt="Play" className="player" />
                              }
                            />
)}
                          </div>
                        ) : (
                          <img
                            src={media.url}
                            alt={`Slide ${index}`}
                            className="w-full max-h-[800px] object-contain rounded-lg transition-transform duration-300"
                            style={{ transform: `scale(${zoomLevels[index] || 1})` }}
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Zoom Buttons (Apply to Active Image Only) */}
                  <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                    <div className="flex">
                      <button onClick={zoomIn} className=" p-2 rounded-lg ">
                        {/* <img src={zoomInicon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                      <button onClick={zoomOut} className=" p-2 rounded-lg">
                        {/* <img src={zoomOuticon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z"
                            fill="#292D32"
                          />
                          <path
                            d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z"
                            fill="#292D32"
                          />
                        </svg>
                      </button>
                    </div>
                    <span className="h-5 border-r border-[#7A7A7A]"></span>
                    <button
                      className=" p-2 rounded-lg "
                      onClick={() => {
                        const url = popupMedia[activeIndex]?.url;
                        if (url) window.open(url, "_blank", "noopener,noreferrer");
                      }}
                    >
                      {/* <img src={exporticon} className="w-[16.8px] h-[16.8px]" /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                      >
                        <path
                          d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z"
                          fill="#292D32"
                        />
                        <path
                          d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z"
                          fill="#292D32"
                        />
                        <path
                          d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z"
                          fill="#292D32"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {!isVideo && (
                  <Swiper
                    onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode
                    watchSlidesProgress
                    className="mt-2"
                  >
                    {popupMedia.map((media, index) =>
                      media.media_type === "image" ? (
                        <SwiperSlide
                          key={index}
                          onClick={() =>
                            thumbsSwiper && thumbsSwiper.slideTo(index)
                          }
                        >
                          <img
                            src={media.url}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-20 md:h-[200px] object-contain rounded-lg cursor-pointer  border border-[#B4B7C9]"
                          />
                        </SwiperSlide>
                      ) : null,
                    )}
                  </Swiper>
                )}
              </div>

              {/* Content Below */}
              <div className="w-full">
                {selectedPostId && selectedPost ? (
                  <div className="share-content relative">
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1 gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="17"
                            viewBox="0 0 19 17"
                            fill="none"
                            className="mx-1"
                          >
                            <path
                              d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z"
                              stroke="#BE1F2E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>{" "}
                          {selectedPost.likeCount}k
                        </button>
                      </div>
                      <button className="flex items-center space-x-1 text-[#fff] share-post-cta ml-3">
                        <img src={shareIcon} alt="Share" className="" />
                        &nbsp;Share
                      </button>
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img
                            src={
                              selectedPost.user?.profile_picture_url ||
                              profileimg
                            }
                            alt={selectedPost.user?.username || "User"}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">
                            {selectedPost.user?.username || "Unknown User"}
                          </p>
                          <p className="flex text-sm text-[#747474]">
                            {formatDateTime(selectedPost.created_at)}{" "}
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex">
                        <div className="view-sharepost-drpdown">
                          {/* <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button> */}

                          {/* {isOpen && (
                            <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Edit</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Delete</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>

                    <p className="my-4 ml-[80px]">
                      {/* {selectedPost.content}jhsbdcjhsbcjhdwbcjhw{" "} */}
                    </p>
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
              {showDonationPopup && selectedDonation && (
                <div className="space-y-2 donation-popup">
                  <h1 className="">{selectedDonation.title || "Campaign"}</h1>

                  <div className="flex items-center space-x-4 text-sm sub-title">
                    <span>{formatDateTime(selectedDonation.created_at)}</span>
                    <div className="flex items-center space-x-1 text-green-700 font-medium">
                      {selectedDonation.isPublic === false ? (
                        <FaLock className="w-4 h-4 mr-3" />
                      ) : (
                        <img
                          src={greenbigglobal}
                          alt="Campaigner"
                          className="w-5 h-15 rounded-full mr-3"
                        />
                      )}
                      <span className="span-public">
                        {selectedDonation.isPublic === false ? "Private" : "Public"}
                      </span>
                    </div>
                  </div>
                  <div>
                    <h2 className="h2-title">Campaign story</h2>
                    <p className="text-sm text-gray-700 mb-4">
                      {selectedDonation.content || "No story available."}
                      {selectedDonation.tags?.map((tag, idx) => (
                        <span
                          key={idx}
                          className="inline-block bg-gray-200 text-xs px-2 py-0.5 rounded ml-1 text-green-800 font-semibold"
                        >
                          #{tag}
                        </span>
                      ))}
                    </p>
                  </div>
                  <h2 className="h2-title">Campaigner</h2>
                  <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center border border-gray-200 p-3 rounded-xl w-full md:w-auto">
                      <img
                        src={
                          selectedDonation.user?.profile_picture_url ||
                          profileimg
                        }
                        alt="Campaigner"
                        className="w-12 h-12 rounded-full border-2 border-yellow-400 mr-3"
                      />{" "}
                      <div>
                        <p className="font-semibold text-sm">
                          {" "}
                          {selectedDonation.user?.first_name}{" "}
                          {selectedDonation.user?.last_name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {" "}
                          {formatDateTime(selectedDonation.created_at)}
                        </p>
                      </div>
                      {/** ✅ Follow state is based only on whether I follow the campaigner */}
                      {selectedDonation.user?.id !== currentUserId && ( // prevent showing follow for self
                        <button
                          className={`ml-auto text-sm px-4 py-1.5 rounded-full ${
                            selectedDonation.myStatus === "accepted"
                              ? "bg-gray-400 text-white"
                              : selectedDonation.myStatus === "pending"
                                ? "bg-yellow-500 text-black"
                                : "text-white bg-green-700 hover:bg-green-800"
                          }`}
                          onClick={() =>
                            handleFollowClick(
                              selectedDonation.user?.id,
                              selectedDonation.user?.privacy_status,
                            )
                          }
                          disabled={
                            selectedDonation.myStatus === "accepted" ||
                            selectedDonation.myStatus === "pending"
                          }
                        >
                          {selectedDonation.myStatus === "accepted"
                            ? "Following"
                            : selectedDonation.myStatus === "pending"
                              ? "Requested"
                              : "Follow"}
                        </button>
                      )}
                    </div>

                    {/* <button className="flex items-center gap-2 bg-green-800 hover:bg-green-900 text-white px-6 py-3 rounded-full text-base w-full md:w-auto justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                                2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 
                                2.09C13.09 3.81 14.76 3 16.5 
                                3 19.58 3 22 5.42 22 8.5c0 
                                3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                    </svg>
                    Donate Now
                  </button> */}
                  </div>
                </div>
              )}
              {/* CHAT FOOTER (INPUT AREA) */}

              <div className="max-w-4xl mx-auto p-6 mt-9">
                <PostDonatePanel
                  key={selectedDonation?.id || selectedPostId}
                  postId={selectedDonation?.id || selectedPostId}
                  donorId={userId}
                  onDonated={(amount, refreshDelay) =>
                    refreshAfterDonation(selectedDonation?.id || selectedPostId, amount, refreshDelay)
                  }
                  onDone={() => setIsdonatenowPopupOpen(false)}
                />
              </div>

              {/* CHAT CONTENT AREA */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
const CommentSection = ({
  comments,
  setComments,
  postId,
  handleCommentSubmit,
  fetchReplies,
  handleCommentLikeClick,
  fetchComments,
  handleFileUpload,
  uploadFiles,
  showEmojiPicker,
  emojiPickerRef,
  handleCommentChange,
  post,
  commentInputs,
  setShowEmojiPicker,
}) => {
  // const [comments, setComments] = useState([]); // Initialize with an empty array
  console.log("Comments State:", comments); // Debugging log
  const user = JSON.parse(
    sessionStorage.getItem("user") || localStorage.getItem("user"),
  );

  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState({});
  const [showReplyBox, setShowReplyBox] = useState({});
  const [uploadedMedia, setUploadedMedia] = useState([]); // Track uploaded media
  const [expandedReplies, setExpandedReplies] = useState({}); // Track expanded replies
  const [filePreviews, setFilePreviews] = useState([]); // Track media previews
  const [sendingCommentId, setSendingCommentId] = useState(null);

  const handleFetchReplies = (commentId) => {
    if (!expandedReplies[commentId]) {
      fetchReplies(commentId); // Fetch replies only if not already expanded
      setExpandedReplies((prev) => ({ ...prev, [commentId]: true })); // Mark as expanded
    } else {
      setExpandedReplies((prev) => ({ ...prev, [commentId]: false })); // Collapse replies
    }
  };

  // Function to add a reply
  const handleAddReply = async (commentId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    const user = JSON.parse(
      sessionStorage.getItem("user") || localStorage.getItem("user"),
    ); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a reply.");
      return;
    }

    const replyContent = replyText[commentId];
    if (!replyContent?.trim()) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/add-comment`,
        {
          media_url: [], // Add media if applicable
          post_id: postId,
          content: replyContent,
          parent_id: commentId, // Use the parent comment ID
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        const newReply = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || profileimg, // Use user's profile picture or default avatar
          text: replyContent,
          time: formatDateTime(response.data.result.created_at),

          likes: 0,
          isLiked: false,
          post_id: postId,
        };

        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? { ...comment, replies: [...comment.replies, newReply] }
              : comment,
          ),
        );

        setReplyText((prev) => ({ ...prev, [commentId]: "" })); // Clear the reply input
        setShowReplyBox((prev) => ({ ...prev, [commentId]: false })); // Hide the reply box

        toast.success("✅ Reply added successfully!");
      } else {
        console.error("Failed to add reply:", response.data.message);
        toast.error(response.data.message || "Couldn't add reply");
      }
    } catch (error) {
      console.error("Error adding reply:", error);
      toast.error(error.response?.data?.message || "Couldn't add reply");
    }
  };
  const handleSubmitComment = async () => {
    const posted = await handleCommentSubmit(postId, commentText, uploadedMedia);
    if (!posted) return; // keep the text so the user can fix it
    setCommentText(""); // ✅ clear the text
    setUploadedMedia([]); // ✅ clear the media attachments
  };
  // Function to remove a file from the preview
  const handleRemoveFile = (index) => {
    setUploadedMedia((prev) => prev.filter((_, i) => i !== index));
    setFilePreviews((prev) => prev.filter((_, i) => i !== index));
  };
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [editingComment, setEditingComment] = useState(null);
  const [editedContent, setEditedContent] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });
  const [coverPic, setCoverPictureUrl] = useState("");

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      if (!token) {
        console.warn("Token not found");
        return;
      }

      try {
        const response = await fetchOwnProfile(token);

        const data = await response.json();

        if (response.ok && data.result) {
          const profilePic = data.result.profile_picture_url;

          if (profilePic) {
            sessionStorage.setItem("profilePictureUrl", profilePic);
            localStorage.setItem("profilePictureUrl", profilePic);
            setProfilePictureUrl(profilePic);
          }

          if (coverPic) {
            setCoverPictureUrl(coverPic);
          }
        } else {
          console.error("Profile fetch error:", data.message);
        }
      } catch (err) {
        console.error("Network error fetching profile:", err);
      }
    };

    fetchUserProfile();
  }, []);

  const toggleDropdown = (id) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  };

  const startEditingComment = (comment) => {
    setEditingComment(comment);
    setEditedContent(comment.text);
    setOpenDropdownId(null);
  };

  const updateComment = async (comment, userId) => {
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/edit-comment`,
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: editedContent,
          media_url: [], // or attach actual media if needed
          is_deleted: false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        setComments((prev) =>
          prev.map((c) =>
            c.id === comment.id ? { ...c, text: editedContent } : c,
          ),
        );
        setEditingComment(null);
        console.log("Comment updated successfully");
      }
    } catch (err) {
      console.error("Error updating comment:", err);
      toast.error(err.response?.data?.message || "Couldn't update comment");
    }
  };

  const deleteComment = async (comment, userId) => {
    if (!window.confirm("Are you sure you want to delete this comment?"))
      return;
    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/edit-comment`,
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: comment.text,
          media_url: [],
          is_deleted: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      if (response.data.success) {
        setComments((prev) => prev.filter((c) => c.id !== comment.id));
        console.log("Comment deleted successfully");
        await fetchComments(comment.post_id);
      }
    } catch (err) {
      console.error("Error deleting comment:", err);
    }
  };

  return (
    <div className="p-4">
      {/* Display Comments and Replies */}
      {comments.map((comment) => (
        <div key={comment.id} className="mb-4 border-b pb-3 relative">
          <div className="flex gap-3">
            <img
              // src={user?.profile_picture_url || profileimg}
              src={comment.avatar || profileimg}
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex-1">
              <div className="bg-[#FEFDEB] p-3 rounded-[20px]">
                <div className="flex justify-between">
                  <p className="font-semibold">{comment.name}</p>
                  <span className="text-[#9397AD] font-[14px]">
                    {comment.time}
                  </span>
                </div>
                {/* <p className="text-gray-700">{comment.text}</p> */}
                {/* {comment.media??.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {comment.media.map((media, idx) =>
                      media.media_type === "image" ? (
                        <img
                          key={idx}
                          src={media.url}
                          alt={`comment-media-${idx}`}
                          className="w-32 h-32 rounded object-cover"
                        />
                      ) : (
                        <video
                          key={idx}
                          controls
                          src={media.url}
                          className="w-64 h-36 rounded"
                        />
                      )
                    ))}
                  </div>
                )} */}
                {editingComment?.id === comment.id ? (
                  <div className="mt-2">
                    <textarea
                      className="w-full p-2 border rounded"
                      value={editedContent}
                      maxLength={1000}
                      onChange={(e) => setEditedContent(e.target.value)}
                    />
                    <button
                      className="mt-1 px-3 py-1 bg-blue-600 text-white rounded"
                      onClick={() => updateComment(comment)}
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  <>
                    <p className="text-gray-700">{comment.text}</p>

                    {/* ✅ A  dd Media Display Block HERE */}
                    {comment.media?.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {comment.media.map((mediaItem, idx) =>
                          mediaItem.media_type === "image" ? (
                            <img
                              key={idx}
                              src={mediaItem.url}
                              alt={`comment-media-${idx}`}
                              className="w-32 h-32 rounded object-cover"
                            />
                          ) : mediaItem.media_type === "video" ? (
                            <video
                              key={idx}
                              controls
                              className="w-64 h-36 rounded"
                            >
                              <source src={mediaItem.url} type="video/mp4" />
                            </video>
                          ) : null,
                        )}
                      </div>
                    )}
                  </>
                )}

                <div className="flex items-center justify-end text-xs text-gray-500 mt-1">
                  <div className="relative">
                    <button
                      onClick={() => toggleDropdown(comment.id)}
                      className="text-gray-500"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                      >
                        <path
                          d="M15 27.5C21.875 27.5 27.5 21.875 27.5 15C27.5 8.125 21.875 2.5 15 2.5C8.125 2.5 2.5 8.125 2.5 15C2.5 21.875 8.125 27.5 15 27.5Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.9956 15H20.0068"
                          stroke="#292D32"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.9941 15H15.0053"
                          stroke="#292D32"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.99313 15H10.0044"
                          stroke="#292D32"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    {openDropdownId === comment.id && (
                      <div className="absolute right-0 bg-white border rounded shadow-md z-10">
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => startEditingComment(comment)}
                        >
                          Edit
                        </button>
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => deleteComment(comment)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    className="ml-4 text-[#095228] font-medium "
                    onClick={() => handleFetchReplies(comment.id)}
                  >
                    {expandedReplies[comment.id]
                      ? "Hide Replies"
                      : "View Replies"}
                  </button>
                  <button
                    className="ml-4 mr-2 text-[#095228] font-medium "
                    onClick={() =>
                      setShowReplyBox((prev) => ({
                        ...prev,
                        [comment.id]: !prev[comment.id], // Toggle reply box for this comment
                      }))
                    }
                  >
                    Reply
                  </button>
                  <div className="flex items-center space-x-1">
                    {/* ✅ Pass 'reply' instead of 'post' */}
                    <LikeButton
                      reply={comment}
                      onClick={() => handleCommentLikeClick(comment.id)}
                    />
                    <span className="ml-2 flex items-center">
                      <img src={messagetext} /> &nbsp;{comment.replies?.length}
                    </span>
                  </div>
                </div>
              </div>

              {/* Reply Input Box */}

              {showReplyBox[comment.id] && (
                <div className="flex items-center mt-2">
                  <input
                    type="text"
                    value={replyText[comment.id] || ""}
                    maxLength={1000}
                    onChange={(e) =>
                      setReplyText((prev) => ({
                        ...prev,
                        [comment.id]: e.target.value, // Update reply text for this comment
                      }))
                    }
                    className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none"
                    placeholder="Write a reply..."
                  />
                  <button
                    onClick={() => handleAddReply(comment.id)}
                    className="ml-2 bg-[#095228] text-[white] px-5 py-2 rounded-[20px]"
                  >
                    Reply
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Render Replies */}
          {expandedReplies[comment.id] && (
            <div className="ml-14 mt-3">
              {comment.replies.map((reply) => (
                <div key={reply.id} className="flex gap-3 mt-2 relative">
                  <img
                    src={leftconnect}
                    className="absolute left-[-50px] z-99 top-[-51px] h-full"
                  />
                  <img
                    src={user?.profile_picture_url || profileimg}
                    alt="User Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <div className="flex-1">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <div className="flex justify-between">
                        <p className="font-semibold">{reply.name}</p>
                        <span className="text-[#9397AD] text-[14px]">
                          {reply.time}
                        </span>
                      </div>
                      <p className="text-gray-700">{reply.text}</p>
                      {/* ✅ Pass 'reply' instead of 'post' */}
                      <div className="flex items-end justify-end space-x-1">
                        <LikeButton
                          reply={reply}
                          onClick={() => handleCommentLikeClick(reply.id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {/* Input for adding a new comment */}
      <div className="flex items-center mb-4">
        <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
          {/* Profile Image Upload */}
          <label className="relative cursor-pointer">
            <img
              src={user?.profile_picture_url || profilePictureUrl}
              className="w-[80px] h-[70px] rounded-full object-cover "
            />
          </label>
        </div>

        <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] relative">
          <div className="flex space-x-2 ml-3 py-4 microphone-sm"></div>

          <input
            placeholder="Add a comment"
            value={commentText}
            maxLength={1000}
            onChange={(e) => setCommentText(e.target.value)}
            className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none"
          />

          <div className="flex space-x-2 ml-3 py-4 chat-media-icon relative">
            <button
              type="button"
              onClick={() => setShowEmojiPicker((prev) => !prev)}
            >
              <img src={smileyIcon} alt="Smiley" className="w-5 h-5" />
            </button>

            <label className="cursor-pointer">
              <img src={galleryicon} alt="Gallery" />
              <input
                type="file"
                multiple
                accept="image/*,video/*"
                className="hidden"
                onChange={handleFileUpload}
              />
            </label>
          </div>

          {/* Media Previews */}
          {filePreviews?.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {filePreviews.map((media, idx) => (
                <div key={idx} className="relative">
                  {media.type === "image" ? (
                    <img
                      src={media.url}
                      alt={`Preview ${idx}`}
                      className="w-20 h-20 object-cover rounded-lg"
                    />
                  ) : (
                    <video
                      src={media.url}
                      controls
                      className="w-32 h-20 rounded"
                    />
                  )}
                  <button
                    onClick={() => handleRemoveFile(idx)}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}

          <button
            type="button"
            className="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3"
            onClick={handleSubmitComment}
          >
            Send
          </button>
        </div>
      </div>
      {showEmojiPicker && (
        <div ref={emojiPickerRef} className="float-right">
          <Picker
            // onSelect={(emoji) =>
            //   handleCommentChange(
            //     post.id,
            //     (commentInputs[post.id] || '') + emoji.native
            //   )
            // }
            data={data}
            onEmojiSelect={(emoji) => {
              setCommentText((prev) => prev + emoji.native);
              setShowEmojiPicker(false);
            }}
            title="Pick an emoji"
          />
        </div>
      )}
    </div>
  );
};
// ✅ Fix: LikeButton is properly structured with useState
const LikeButton = ({ reply, onClick }) => {
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    setLiked(reply?.isLiked || false);
  }, [reply]);

  const handleClick = () => {
    setLiked(!liked);
    onClick(); // Call parent handler
  };

  return (
    <div className="mr-2">
      <span
        className="flex items-center space-x-1 cursor-pointer"
        onClick={handleClick}
      >
        <img
          src={liked ? Redheart : RedlikeIcon}
          alt="Like Icon"
          className={`transition duration-300 ${liked ? "w-6 h-6" : "w-6 h-5"}`}
        />
        <span>{reply?.likes}</span>
      </span>
    </div>
  );
};
